import LocalizedStrings from "react-localization"
import RecognizeAbility from "../features/frontoffice/components/inputs/RecognizeAbility"

export const languages = ["sk"]
export const translations = new LocalizedStrings({
    sk: {
        subscriptionStatus: {
            canceled: "Zrušené",
            unpaid: "Nezaplatené",
            past_due: "Po splatnosti",
            incomplete_expired: "Nedokončené"
        },
        artifacts: {
            SignatureCanvasArtifact: {
                createSignature: "Vytvorte podpis",
                create: "Vytvoriť",
                loadFile: "alebo nahrajte súbor",
                signature: "Podpis",
                missingSignatures: 'Chýbajú podpisy prstom následujúcich osôb, po podpísaní KEP-om už nebude možné ich pridať.',
                save: "Použiť",
                clear: "Zmeniť",
                close: 'Zatvoriť',
                orderDetail: 'Detail objednávky'
            },
            DocumentOverview: {
                documentOverview: "Náhľad dokumentu",
                cancel: 'Zavrieť',
                preview: 'Náhľad'
            },
            ProcessDocuments: {
                uploadImageForScanning: "Nahrať/Odfotiť doklad",
                uploadImageForScanningTooltip: "Nahrajte foto/scan OP alebo pasu a údaje sa automaticky vyplnia."
            },
            ProcessDocumentsSeparatedName: {
                uploadImageForScanning: "Nahrať/Odfotiť doklad",
                uploadImageForScanningTooltip: "Nahrajte foto/scan OP alebo pasu a údaje sa automaticky vyplnia.",
                signIn: "Pre využitie tejto funkcionality sa prosím prihláste."
            },
            AdressAutocompleteInputsBox: {
                adress: "ulica a č., PSČ, mesto",
            },
            AddressAutoCompleteSeperatedInputBox: {
                street: "Ulica",
                streetSmall: "- ulica",
                streetSmallSecond: "Ulica",
                adressNumber: "Číslo",
                city: "Mesto",
                poscode: "PSČ",
                chooseCountry: "Vyberte krajinu",
                country: "Krajina",
            },
            BaseInvestmentBox: {
                baseFinance: "Základné imanie"
            },
            BusinessTransferBox: {
                companyPart: "časť podniku",
                fullCompany: "celý podnik",
                enterPartCompanyName: "Zadajte názov časti podniku",
                partCompanyName: "Názov časti podniku",
            },
            CompanyAvailabilityInputBox: {
                forSure: "Vami zvolené obchodné meno zatiaľ nepoužíva žiadna iná spoločnosť. Pre zvýšenie Vašej právnej istoty sme to aktuálne skontrolovali na",
                orsrsk: "orsr.sk",
                unavailable: "Vami zvolené obchodné meno už niekto používa. Vyberte iné"
            },
            ContractModalBox: {
                title: "Zmluva o poskytovaní služieb",
                parties: "Zmluvné strany",
                lawyersOffice: "Advokátska kancelária Matejka Friedmannová s. r. o.",
                withCompanyAdress: ", so sídlom na adrese: Dunajská ul. 48, 811 08 Bratislava, IČO: 47 248 998, IČ DPH: SK 2023808765, obchodná spoločnosť zapísaná v Obchodnom registri vedenom Mestským súdom Bratislava III, oddiel Sro, vložka č. 90113/B, v mene ktorej koná: JUDr. Ondrej Matejka, konateľ oprávnený konať samostatne (ďalej v texte len „",
                and: "a",
                lawyer: "Advokát",
                orAnd: "“ a/alebo „",
                operator: "Prevádzkovateľ",
                withAdress: ", so sídlom na adrese: ",
                companyWrittenIn: ", obchodná spoločnosť zapísaná v Obchodnom registri vedenom: ",
                part: ", oddiel: ",
                insert: ", vložka č.: ",
                order: ", v mene ktorej je oprávnená samostatne a bez akýchkoľvek obmedzení konať osoba uskutočňujúca Dokončenie objednávky (ďalej v texte len „",
                client: "Klient",
                user: "Používateľ",
                canActAlone: ", v mene ktorej je oprávnená samostatne a bez akýchkoľvek obmedzení konať osoba uskutočňujúca Dokončenie objednávky (ďalej v texte len „",
                articleOne: "Článok I",
                baseAgreement: "Základné zmluvné dojednania",
                firstRule: "Advokát sa zaväzuje poskytnúť Klientovi Služby Aplikácie za podmienok dojednaných touto Zmluvou o poskytnutí služieb a za podmienok stanovených VOP",
                definatedDown: "pojem definovaný nižšie v texte",
                secondRule: "Potrebu poskytnutia právnej pomoci sa Klient zaväzuje špecifikovať Advokátovi výlučne len zadaním požiadaviek Používateľa do Aplikácie, pričom za validné zadanie požiadaviek Používateľa na poskytnutie Služieb Aplikácie sa považuje výlučne len Dokončenie objednávky.",
                thirdRule: "Advokát začína poskytovať Klientovi Služby Aplikácie okamihom bezprostredne nasledujúcim po Dokončení objednávky.",
                fourthRule: "Advokát zodpovedá za Právnu časť Dokumentov, ktoré vytvoril počas trvania tejto Zmluvy o poskytnutí služieb.",
                fifthRule: "Klient sa zaväzuje podrobne sa v Aplikácii oboznámiť so všetkými dostupnými poučeniami Advokáta, s VOP ",
                fifthRuleTwo: ", so zásadami nakladania so súbormi cookie, a so zásadami spracovávania osobných údajov. ",
                sixsthRule: "Advokát odovzdáva Klientovi poskytnuté Služby Aplikácie po komplexnom ukončení spracovania celej požiadavky Klienta.",
                seventhRule: "Advokát odovzdáva Klientovi poskytnuté Služby Aplikácie výlučne len spôsobom Doručenia Vygenerovaných Dokumentov Používateľovi.",
                eightRule: "Advokát uskutočňuje Doručenie Vygenerovaných Dokumentov Používateľovi po uhradení Ceny, spravidla v lehote piatich minút po uhradení Ceny; nedodržanie tejto lehoty môže byť spôsobené najmä nestálosťou internetového pripojenia Používateľa a/alebo akoukoľvek inou technickou nedostatočnosťou internetového pripojenia Používateľa a/alebo akoukoľvek technickou nedostatočnosťou Zariadenia Používateľa a/alebo Aplikáciou.",
                ninethRule: "Klient je oprávnený reklamovať Advokátom poskytnuté Služby Aplikácie podľa príslušných ustanovení Obchodného zákonníka. ",
                articleTwo: "Článok II ",
                lawyersPrize: "Odmena advokáta a platobné podmienky",
                tenthRule: "Klient sa zaväzuje za poskytnutie Služieb Aplikácie zaplatiť Advokátovi Cenu.",
                eleventhRule: "Cena je dojednaná ako paušálna odmena a riadi sa vyhláškou MS SR č. 655/2004 Z. z. o odmenách a náhradách advokátov za poskytovanie právnych služieb a touto Zmluvou o poskytnutí služieb.",
                twelveRule: "Advokát fakturuje Cenu za poskytnuté Služby Aplikácie vždy po komplexnom ukončení spracovania celej požiadavky Klienta.",
                thirtteenthRule: "Podmienky vystavenia faktúry, odoslania faktúry a doručenia faktúry sú obsiahnuté vo VOP ",
                articleThree: "Článok III",
                termsAndConditions: "Vzťah Zmluvy o poskytnutí služieb a Všeobecných obchodných podmienok",
                fourthteenthRule: " Advokát ustanovil Všeobecné obchodné podmienky pre poskytovanie",
                fourthteenthRuleSecond: "právnych služieb použitím Aplikácie a na Internetovej adrese ich Advokát zverejnil pred uzatvorením tejto Zmluvy o poskytnutí služieb v znení, v akom sú VOP účinné ku dňu uzatvorenia tejto Zmluvy o poskytnutí služieb (ďalej v texte len „",
                VOP: "VOP",
                fifthteenthRule: "Neoddeliteľnou súčasťou tejto Zmluvy o poskytnutí služieb sú VOP.",
                sixteenthRule: "V prípade rozporu/kolízie/nesúladu medzi textom tejto Zmluvy o poskytnutí služieb a textom VOP, majú prednosť dojednania obsiahnuté v tejto Zmluve o poskytnutí služieb.",
                articleFour: "Článok IV",
                commonProvisions: "Common provisions",
                seventeenthRule: "Táto Zmluva o poskytnutí služieb sa medzi zmluvnými stranami uzatvára elektronicky použitím Aplikácie.",
                eighteenthRule: "Uskutočnením Dokončenia objednávky nastáva okamih, kedy je medzi Prevádzkovateľom a Používateľom uzatvorená táto Zmluva o poskytnutí služieb.",
                nineteenthRule: "Táto Zmluva o poskytnutí služieb nadobúda platnosť okamihom jej uzatvorenia. ",
                twentiethRule: "Ak nie je uvedené inak, táto Zmluva o poskytnutí služieb vyvoláva právne účinky okamihom jej uzatvorenia.",
                twentyFirstRule: "Povinnosť Prevádzkovateľa Doručiť Vygenerované Dokumenty Používateľovi, nastáva až okamihom zaplatenia Ceny. Používateľ berie na vedomie a výslovne súhlasí s tým, že Prevádzkovateľ nie je povinný Používateľovi Doručiť Vygenerované Dokumenty skôr, než Používateľ zaplatí Prevádzkovateľovi Cenu.",
                twentySecondRule: "Táto Zmluva o poskytnutí služieb sa uzatvára na neurčitý čas. ",
                twentyThirdRule: "Táto Zmluva o poskytnutí služieb je platná a záväzná aj pre právnych nástupcov zmluvných strán. ",
                twentyFourRule: "Advokát sa pri poskytovaní právnej pomoci a právnych služieb riadi platnými právnymi predpismi upravujúcimi výkon advokácie a záväznými predpismi a usmerneniami Slovenskej advokátskej komory. ",
                twentyFiveRule: "Klient udeľuje Advokátovi súhlas použiť verejne dostupné informácie o Klientovi na účely prezentácie Advokáta, najmä udeľuje Advokátovi súhlas použiť obchodné meno a ochrannú známku Klienta na účely referencií Advokáta.",
                articleFive: "Článok V",
                finalProvisions: "Záverečné ustanovenia",
                twentySixRule: "Zmluvné strany považujú obsah tejto Zmluvy o poskytnutí služieb za dôverný a zaväzujú sa ho chrániť. Zmluvné strany sa dohodli, že žiadna z nich samostatne, bez predchádzajúceho súhlasu druhej strany, nebude tretie osoby informovať o obsahu tejto Zmluvy o poskytnutí služieb, ani o právach a povinnostiach z nej pre zmluvné strany vyplývajúcich; uvedené sa nevzťahuje na prípady informačných a oznamovacích povinností vyplývajúcich zmluvným stranám z osobitných právnych predpisov.",
                twentySevenRule: "Klient svojim podpisom na tejto Zmluve o poskytnutí služieb potvrdzuje, že na uzatvorenie tejto Zmluvy o poskytnutí služieb v mene Klienta sú splnené všetky podmienky a predpoklady stanovené jeho internými predpismi a všeobecne záväznými právnymi predpismi, a že táto Zmluva o poskytnutí služieb je za zmluvnú stranu Klienta uzatvorená osobou na to bez obmedzení a bez výhrad oprávnenou v zmysle všeobecne záväzných právnych predpisov.",
                twentyEightRule: "Zmluvné strany vyhlasujú, že sa zdržia akéhokoľvek konania, ktoré by znemožnilo alebo sťažilo naplnenie predmetu tejto Zmluvy o poskytnutí služieb.",
                twentyNineRule: "Klient vyhlasuje, že si túto Zmluvu o poskytnutí služieb pozorne prečítal, jej obsahu dobre porozumel, že táto Zmluva o poskytnutí služieb je prejavom jeho slobodnej, vážnej a určitej vôle, že túto Zmluvu o poskytnutí služieb uzatvára slobodne a nie v tiesni a ani nie za nevýhodných podmienok, na znak čoho Klient pristúpil k uzatvoreniu tejto Zmluvy o poskytnutí služieb.",
                thirtyRule: "Táto zmluva sa vyhotovuje elektronicky.",
            },
            EstablishmentPeriodBox: {
                companyIsMake: "Spoločnosť sa zakladá na dobu",
                forever: "Na dobu neurčitú",
                onDate: "Do dátumu",
                chooseDate: "Vyberte dátum",
            },
            GuidanceModalBox: {
                lawyersInfo: "Rady a odporúčania advokáta",
                complexInfo: "Zhrnuli sme pre Vás dôležité informácie. Ďakujeme a pokračujeme",
                readInfo: "Odporúčania advokáta som si prečítal(a)",
                lawyerAdvice: "Rady a odporúčania advokáta",
            },
            NewCompanyAddressBox: {
                companyAdress: "Sídlo spoločnosti bude na adrese",
                cityAdress: "Ulica a č., PSČ, Mesto",
                tooltip: "Je potrebné správne napísať celú adresu, na ktorej bude nové sídlo spoločnosti, aby ste nemali problémy s doručovaním písomností"
            },
            NewCompanyNameBox: {
                companyName: "Názov spoločnosti"
            },
            numberOfPropertyOwners: {
                numberOfPropertyOwnersText: "Koľko osôb vlastní nehnuteľnosť kde bude sídlo?",
                numberOfOwnersTooltip: "Ak si neprajete vygenerovať súhlas vlastníka nehnuteľnosti, nechajte prázdne, alebo zvoľte 0"
            },
            RecognizeAbilityBox: {
                recognizeAbilityText: "Podľa Obchodného zákonníka na konanie valného zhromaždenia a na prijímanie rozhodnutí o jednotlivých bodoch programu musia byť prítomní spoločníci, ktorí majú aspoň 50% zo všetkých hlasov, ale v spoločenskej zmluve sa môže určiť aj vyšší alebo nižší počet potrebných hlasov. Ako je to v tejto spoločnosti? Koľko % hlasov všetkých spoločníkov je potrebných?",
                noLimits: " Táto spoločnosť nemá žiadne špeciálne podmienky pre konanie valného zhromaždenia a pre hlasovanie, než tie, aké určuje Obchodný zákonník"
            },
            RepresentationBox: {
                representation: "Podáme to za Vás",
                wantRepresentation: "Podáme to za Vás na Obchodný register SR?",
                freeService: "Ak si túto službu vyberiete TERAZ, je bezplatná",
                moreInfo: "Viac informácií nájdete v Cenníku.",
                yes: "Áno",
                no: "Nie",
                thankYou: "Ďakujeme, radi Vás budeme zastupovať.",
                orsr: "na Obchodný register?",

            }, SelectBoardBox: {
                nameTitleSurname: "Titul, meno, priezvisko"
            },
            KonatelBox: {
                otherAdress: "Iná adresa",
                otherPerson: "Iná osoba",
                enterTitle: "Zadajte tituly pred menom",
                enterTitleAfter: "Zadajte tituly za menom",
                titleAfter: "Tituly za menom",
                enterName: "Zadajte meno",
                name: "Meno",
                enterSurname: "Zadajte priezvisko",
                surname: "Priezvisko",
                beforeName: "Tituly pred menom",
                selectAdress: "Zadajte adresu",
                enterName: "Meno konateľa je",
                nameTitleSurname: "Titul, meno, priezvisko"
            },
            LikvidatorBox: {
                otherPerson: "Iná osoba",
                otherAdress: "Iná adresa",
                selectAdress: "Zadajte adresu",
                enterName: "Meno likvidátora je",
                nameTitleSurname: "Titul, meno, priezvisko",
                enterTitlesBeforeName: "Zadajte tituly pred menom",
                titlesBefore: "Tituly pred menom",
                enterTitlesAfter: "Zadajte tituly za menom",
                titlesAfter: "Tituly za menom",
                enterName: "Zadajte meno",
                enterSurname: "Zadajte priezvisko",
                surname: "Priezvisko",
                name: "Meno",
            },
            SelectPaymentBox: {
                choose: "- Vyberte -",
                cash: "V hotovosti",
                transfer: "Prevodom na účet",
                didRecieve1: "Prevzal",
                didRecieve2: "dojednanú odplatu?",
            },
            ProkuristaBox: {
                otherAdress: "Iná adresa",
                otherPerson: "Iná osoba",
                enterTitles: "Zadajte tituly pred menom",
                titlesBefore: "Tituly pred menom",
                enterTitlesAfter: "Zadajte tituly za menom",
                titlesAfter: "Tituly za menom",
                enterName: "Zadajte meno",
                name: "Meno",
                enterSurname: "Zadajte priezvisko",
                surname: "Priezvisko",
                selectAdress: "Zadajte adresu",
                nameTitleSurname: "Titul, meno, priezvisko"
            },
            SpolocnikBox: {
                otherPerson: "Iná osoba",
                otherAdress: "Iná adresa",
                selectAdress: "Zadajte adresu",
                nameTitleSurname: "Titul, meno, priezvisko",
                enterName: "Zadajte meno",
            },
            TitleNameSurnameArtifact: {
                titlesBeforeName: "Tituly pred menom",
                titlesAfterName: "Tituly za menom",
                name: "Meno",
                surname: "Priezvisko",
            },
            RegistrationCertificateArtifact: {
                labelOwner: "Vlastník vozidla",
                labelHolder: "Držiteľ vozidla",
                labelData: "Údaje o vozidle",
                tooltipTextOwner: "Zadajte údaje o vlastníkovi vozidla",
                tooltipHolderText: "Zadajte údaje o držitelovi vozidla",
                tooltipDataText: "Zadajte údajej o vozidle",
                differentHolder: "Je držiteľ odlišný od vlastníka?",
                owner: "Vlastníkom je",
                holder: "Držiteľom je",
                uploadImageForScanning: "Nahrať/Odfotiť TP",
                uploadImageForScanningTooltip: "Nahrajte foto/scan TP a údaje sa automaticky vyplnia.",
                savedPersonsButton: "Vyberte inú osobu ako na TP"
            },
            RegistrationCertificatePersonBox: {
                choosePersonType: 'Je to človek?',
                individual: "Človek",
                legalPerson: "Právnická osoba",
                selectName: "Zadajte meno",
                selectAdress: "Zadajte adresu",
                searchOrsr: "Vyhľadať v ORSR",
                enterICO: "IČO / identifikátor je",
                enterBirthID: "Rodné číslo / identifikátor je",
                enterICOTooltip: "V niektorých krajinách neprideľujú právnickým osobám IČO, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.",
                enterBirthIDTooltip: "V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.",
                enterICOPlaceholder: 'napíšte IČO alebo iný identifikačný udaj',
                enterBirthIDPlaceholder: 'napíšte rodné číslo alebo iný identifikačný udaj',
                chooseBirthDate: "Vyberte dátum narodenia",
                birthDate: 'Dátum narodenia',
            },
            RegistrationCertificateDataBox: {
                registrationNumber: "Číslo technického preukazu",
                registrationNumberId: "Číslo technického preukazu",
                yearOfProduction: "Rok výroby",
                yearOfProductionId: "B",
                model: "Druh",
                modelId: "1",
                brand: "Znacka",
                brandId: "D.1",
                type: "Typ",
                typeId: "D.2",
                color: "Farba",
                colorId: "22 R",
                vin: "VIN",
                vinId: "E",
                licensePlate: "Poznávacia značka",
                licensePlateId: "A",
            },
            ProcessDocumentsSeparatedName: {
                signIn: "Pre využitie tejto funkcionality sa prosím prihláste."
            },
            VOPmodalBox: {
                vopIntro: "Advokátska kancelária Matejka Friedmannová s. r. o., so sídlom na adrese: Dunajská 48, 811 08 Bratislava – m. č. Staré Mesto, Slovenská republika, IČO: 47 248 998, zapísaná v Obchodnom registri vedenom Mestským súdom Bratislava III, oddiel Sro, vložka č. 90113/B, ustanovila pre používanie aplikácie MOJEZMLUVY.SK a pre poskytovanie právnych služieb použitím aplikácie MOJEZMLUVY.SK Všeobecné obchodné podmienky v následovnom znení (ďalej len „",
                vop: "VOP",
                articleOne: "Článok I",
                mainDefinitions: "Základné pojmy a definície",
                aplication: "„Aplikácia“ ",
                b2bApp: "znamená softvérová B2B [business-to-business] aplikácia s názvom MOJEZMLUVY.SK vyvinutá Prevádzkovateľom a používaná Prevádzkovateľom ",
                contract: "uzatvorenie Zmluvy o poskytnutí služieb s Používateľom, ",
                using: "na poskytovanie Služieb Aplikácie a",
                payPrice: "na zabezpečenie zaplatenia Ceny za poskytnutie Služieb Aplikácie; súčasťou Aplikácie je internetová stránka dostupná z Internetovej adresy;",
                copyrightLaw: "„Autorský zákon“",
                copyMeans: "znamená zákon č. 185/2015 Z. z. autorský zákon v znení neskorších predpisov;",
                price: "„Cena“ ",
                definition: "znamená sumu elektronicky dohodnutú podľa Cenníka Služieb medzi Prevádzkovateľom a Používateľom za poskytnutie jednotlivých Služieb Aplikácie Používateľovi, ktorú sa Používateľ zaväzuje zaplatiť Prevádzkovateľovi použitím zabezpečenej platobnej brány Aplikácie. Cena je uvedená najmä v časti Aplikácie s názvom Košík, pričom výška Ceny sa odvíja od rozsahu Používateľovej objednávky Služieb Aplikácie. Cena neobsahuje žiadne skryté poplatky. Cena je konečná a je uvádzaná v členení na sumu základu dane z pridanej hodnoty a sumu dane z pridanej hodnoty. V Cene je zahrnutá aj náhrada hotových administratívnych výdavkov Prevádzkovateľa;",
                priceList: "„Cenník Služieb“ ",
                priceDefinition: "znamená cenník určený Prevádzkovateľom pre poskytovanie Služieb Aplikácie a aktuálny ku dňu poskytnutia Služieb Aplikácie Používateľovi. Cenník Služieb obsahuje najmä sumy cien a poplatkov a je zverejnený na Internetovej adrese;",
                civilOrder: "„Civilný mimosporový poriadok“",
                lawDefinition: "znamená zákon č. 161/2015 Z. z. Civilný mimosporový poriadok v znení neskorších predpisov;",
                completeOrder: "„Dokončenie objednávky“",
                itMeans: "znamená vyplnenie všetkých povinných polí objednávkového formulára Aplikácie Používateľom a potvrdenie objednávky Používateľa uskutočnením aktívneho kliknutia Používateľa na príslušné tlačidlo v Aplikácii ",
                finishOrder: " s nápisom „Dokončiť objednávku s povinnosťou platby“ alebo ",
                button: "na príslušné tlačidlo v Aplikácii s iným nápisom rovnakého obsahového významu;",
                document: "„Dokument“",
                partsOfDocument: "znamená ucelenú a vzájomne prepojenú časť Aplikácie, zobrazujúcu Používateľovi textové pole s obsahom súvisiacim od rozsahu Používateľovej objednávky Služieb Aplikácie; Dokument sa člení na",
                firstPartDocument: "Právnu časť Dokumentu a ",
                infoByUser: "Údaje vyplnené Používateľom. Dokument sa Používateľovi v Aplikácii zobrazuje najmä za tým účelom, aby Prevádzkovateľ poskytol Používateľovi online náhľad na konzistenciu a gramatickú súvsťažnosť Údajov vyplnených Používateľom s Právnou časťou Dokumentu. Zobrazovaním Dokumentu Aplikácia umožňuje Používateľovi online kontrolou zistiť chybu/nedostatok/nesprávnosť Údajov vyplnených Používateľom a umožňuje Používateľovi vykonať opravu/doplnenie Údajov vyplnených Používateľom v používateľskom rozhraní Aplikácie;",
                deliverDocuments: "„Doručenie Vygenerovaných Dokumentov“",
                means: "znamená",
                downloadDocuments: "sprístupnenie možnosti stiahnutia Vygenerovaných Dokumentov v Aplikácii do Zariadenia Používateľa a/alebo",
                hyperLink: "odoslanie hyperlinku pre možnosť stiahnutia Vygenerovaných Dokumentov na e-mailovú adresu zadanú Používateľom v objednávkovom formulári Aplikácie a odoslanie hesla na otvorenie zaslaného hyperlinku na mobilné telefónne číslo zadané Používateľom v objednávkovom formulári Aplikácie. Validné Doručenie Vygenerovaných Dokumentov Používateľovi nastane aj vtedy, ak ",
                downloadFromApp: "Používateľ nevyužije možnosť stiahnuť si z Aplikácie do Zariadenia Používateľa Vygenerované Dokumenty a/alebo ",
                badUserInfo: "ak Používateľ v objednávkovom formulári Aplikácie uvedie neexistujúcu/nefungujúcu/nesprávnu/neplatnú e-mailovú adresu a/alebo neexistujúce/nefungujúce/nesprávne/neplatné mobilné telefónne číslo;",
                internetAdress: "„Internetová adresa“",
                anyAdress: "znamená akúkoľvek internetovú adresu, z ktorej je dostupná Aplikácia, najmä internetová stránka https://www.mojezmluvy.sk/;",
                itAdmin: "„IT admin“",
                itAdminMeans: "znamená označenie pre každú fyzickú osobu vyslovene oprávnenú Prevádzkovateľom na vstup do admin rozhrania Aplikácie;",
                gdpr: "„Nariadenie GDPR“",
                gdprMeans: "znamená Nariadenie Európskeho parlamentu a Rady (EÚ) 2016/679 z 27. apríla 2016 o ochrane fyzických osôb pri spracúvaní osobných údajov a o voľnom pohybe takýchto údajov, ktorým sa zrušuje smernica 95/46/ES (všeobecné nariadenie o ochrane údajov);",
                register: "„Obchodný register SR“",
                registerMeans: "znamená verejný zoznam, do ktorého sa zapisujú zákonom stanovené údaje týkajúce sa podnikateľov, prípadne iných osôb, o ktorých to ustanovuje osobitný zákon;",
                commercialCode: "„Obchodný zákonník“",
                commercialMeans: "znamená zákon č. 513/1991 Zb. Obchodný zákonník v znení neskorších predpisov;",
                civilCode: "„Občiansky zákonník“",
                civilMeans: "znamená zákon č. 40/1964 Zb. Občiansky zákonník v znení neskorších predpisov;",
                personInfo: "„Osobné údaje“",
                personMeans: "znamená údaje týkajúce sa identifikovanej fyzickej osoby alebo identifikovateľnej fyzickej osoby, ktorú možno identifikovať priamo alebo nepriamo, najmä na základe všeobecne použiteľného identifikátora, iného identifikátora, ako je napríklad meno, priezvisko, identifikačné číslo, lokalizačné údaje, alebo online identifikátor, alebo na základe jednej alebo viacerých charakteristík alebo znakov, ktoré tvoria jej fyzickú identitu, fyziologickú identitu, genetickú identitu, psychickú identitu, mentálnu identitu, ekonomickú identitu, kultúrnu identitu alebo sociálnu identitu.",
                user: "„Používateľ“",
                userMeans: "znamená obchodnú spoločnosť zapísanú v Obchodnom registri SR; alebo obchodnú spoločnosť, ktorá bude Službou Aplikácie založená; ktorá používa Aplikáciu za účelom kúpenia Služieb Aplikácie. Používateľ nie je fyzická osoba. Používateľ nie je spotrebiteľ. Používateľ je povinný na vlastnú zodpovednosť zabezpečiť, že Aplikáciu používajú v jeho mene osoby na to oprávnené v zmysle ustanovení § 20 Občianskeho zákonníka;",
                lawDocument: "„Právna časť Dokumentu“",
                lawDocumentMeans: "znamená textové pole Dokumentu vytvorené Prevádzkovateľom a obsahujúce úplný text a/alebo časť textácie o.i. zápisnice z valného zhromaždenia, zmluvy, dohody, vyhlásenia, alebo v Aplikácii inak označeného Dokumentu právne relevantného pre konanie vo veciach obchodného registra podľa Civilného mimosporového poriadku;",
                operator: "„Prevádzkovateľ“",
                operatorMeans: "znamená obchodnú spoločnosť, advokátsku kanceláriu Matejka Friedmannová s. r. o., so sídlom na adrese: Dunajská 48, 811 08 Bratislava – m. č. Staré Mesto, Slovenská republika, IČO: 47 248 998, email: orsr.help@matejka.company, zapísanú v Obchodnom registri vedenom Mestským súdom Bratislava III, oddiel Sro, vložka č. 90113/B, ktorá je vlastníkom a administrátorom Aplikácie. Prevádzkovateľ v zmysle Nariadenia GDPR a Zákona o ochrane osobných údajov vymedzil účel a prostriedky spracúvania Osobných údajov a spracúva Osobné údaje vo vlastnom mene;",
                appServices: "„Služby Aplikácie“",
                appServicesMeans: "znamená spoločné označenie pre jednorazové poskytnutie právnej služby Používateľovi, ktorú Prevádzkovateľ poskytuje Používateľovi podľa Zákona o advokácii, za podmienok dojednaných v Zmluve o poskytnutí služieb a výlučne len použitím Aplikácie, a obsahom ktorej [právnej služby] je ",
                appServicesMeansOne: "spísanie listín na zmenu údajov zapísaných Používateľovi v Obchodnom registri SR podľa požiadaviek Používateľa zadaných v Aplikácii Dokončením objednávky a/alebo spísanie listín na založenie Používateľa podľa požiadaviek Používateľa zadaných v Aplikácii Dokončením objednávky, a",
                appServicesMeansTwo: "vyhotovenie Dokumentov, a",
                documentGeneration: "Vygenerovanie Dokumentov, a",
                deliverGeneratedDocuments: "Doručenie Vygenerovaných Dokumentov Používateľovi;",
                consumer: "„Spotrebiteľ“ ",
                consumerMeans: "znamená fyzická osoba, ktorá pri používaní Aplikácie nekoná v rámci predmetu svojej obchodnej činnosti alebo inej podnikateľskej činnosti.",
                dataByUser: "„Údaje vyplnené Používateľom“",
                dataByUserMeans: "znamená textové pole Dokumentu vytvorené Používateľom v používateľskom rozhraní Aplikácie;",
                generatedDocument: "„Vygenerovaný Dokument“",
                generatedDocumentsMeans: "znamená needitovateľný súbor formátu „pdf“, „docx“, „odt“, „rtf“ a/alebo iného bežne používaného formátu s obsahom textovo totožným obsahu Dokumentu v okamihu Dokončenia objednávky;",
                advocacyLaw: "„Zákon o advokácii“",
                advocacyLawMeans: "znamená zákon č. 586/2003 Z. z. o advokácii a o zmene a doplnení zákona č. 455/1991 Zb. o živnostenskom podnikaní (živnostenský zákon) v znení neskorších predpisov;",
                eGoverment: "„Zákon o e-Governmente“",
                eGovermentMeans: "znamená zákon č. 305/2013 Z. z. o elektronickej podobe výkonu pôsobnosti orgánov verejnej moci a o zmene a doplnení niektorých zákonov (zákon o e-Governmente) v znení neskorších predpisov;",
                userDataLaw: "„Zákon o ochrane osobných údajov“",
                userDataLawMeans: "znamená zákon č, 18/2018 Z. z. o ochrane osobných údajov a o zmene a doplnení niektorých zákonov;",
                userDevice: "„Zariadenie Používateľa“",
                userDeviceMeans: "znamená akékoľvek zariadenie, najmä desktop PC, laptop, notebook, smart-phone a iné zariadenie, použitím ktorého Používateľ používa Aplikáciu;",
                userRepresentation: "„Zastupovanie Používateľa“",
                userRepresentationOne: "znamená právne zastupovanie Používateľa podľa príslušných ustanovení Civilného mimosporového poriadku, podľa Zákona o advokácii a podľa ostatných príslušných právnych predpisov právne záväzných v Slovenskej republike, na základe osobitného písomného plnomocenstva udeleného Prevádzkovateľovi, ",
                userRepresentationTwo: "v konaní o zápis zmeny/zmien údajov zapísaných o Používateľovi v Obchodnom registri SR, výlučne však len v rozsahu Služieb Aplikácie poskytnutých Používateľovi spôsobom Doručenia Vygenerovaných Dokumentov a/alebo ",
                userRepresentationThree: "v konaní o prvozápis Používateľa do Obchodného registra SR, výlučne však len v rozsahu Služieb Aplikácie poskytnutých Používateľovi spôsobom Doručenia Vygenerovaných Dokumentov. Prevádzkovateľ je povinný uskutočniť Zastupovanie Používateľa len ak sú kumulatívne splnené všetky následovné podmienky:",
                printDocuments: "Používateľ vytlačil všetky Vygenerované Dokumenty a nespravil do ich textu žiaden zásah a zabezpečil na nich podpisy konajúcich osôb tak, ako to vyplýva z Vygenerovaných Dokumentov,",
                allDocuments: "Používateľ všetky dokumenty podľa bodu 26.1. týchto VOP do 25 dní od Doručenia Vygenerovaných Dokumentov doručil Prevádzkovateľovi, a to ",
                allDocumentsOne: "formou originálu jedného rovnopisu každého Vygenerovaného Dokumentu v listinnej podobe a doručeného Prevádzkovateľovi na adresu sídla Prevádzkovateľa, alebo",
                allDocumentsTwo: "formou elektronického dokumentu podpísaného kvalifikovaným elektronickým podpisom [KEP] a doručeného do elektronickej schránky Prevádzkovateľa zriadenej na Ústrednom portáli verejnej správy na adrese www.slovensko.sk podľa Zákona o e-Governmente.",
                finishOrderLaw: "Používateľ Dokončením objednávky udeľuje Prevádzkovateľovi výslovný, neodvolateľný, nepodmienený, nemenný, časovo ani inak neobmedzený pokyn, aby Prevádzkovateľ pri Zastupovaní Používateľa neuskutočnil žiadnu kontrolu správnosti/úplnosti/pravdivosti Údajov vyplnených Používateľom a aby Prevádzkovateľ neuskutočnil žiadnu kontrolu úplnosti dokumentov požadovaných právnymi predpismi na Zastupovanie Používateľa.",
                userPresentation: "Prevádzkovateľ uskutoční Zastupovanie Používateľa ",
                recordChanges: "konaní o zápis zmeny/zmien údajov zapísaných o Používateľovi v Obchodnom registri SR podaním elektronického návrhu na príslušný registrový súd alebo ",
                recordChangesOne: " v konaní o ohlásenie živnostenských oprávnení a zápis zmien údajov zapísaných o Používateľovi v Obchodnom registri SR na základe ustanovení Smernice 2006/123/ES o službách na vnútornom trhu podaním elektronického návrhu na elektronické jednotné kontaktné miesto v Slovenskej republike alebo ",
                recordChangesTwo: "v konaní o ohlásenie živnostenských oprávnení a prvozápis Používateľa v Obchodnom registri SR na základe ustanovení Smernice 2006/123/ES o službách na vnútornom trhu podaním elektronického návrhu na elektronické jednotné kontaktné miesto v Slovenskej republike, a ",
                recordChangesThree: "doručením rozhodnutia vydaného v konaní podľa predchádzajúcich písm. (a), (b) alebo (c) tejto vety na e-mailovú adresu zadanú Používateľom v objednávkovom formulári Aplikácie;",
                changesContract: "„Zmluva o poskytnutí služieb“ ",
                changesContractMeans: "znamená písomnú zmluvu elektronicky uzatvorenú v Aplikácii medzi Používateľom a Prevádzkovateľom, na základe ktorej sa Prevádzkovateľ zaväzuje poskytnúť Používateľovi Služby Aplikácie a Používateľ sa zaväzuje zaplatiť Prevádzkovateľovi Cenu. Zmluva o poskytnutí služieb upravuje práva a povinností Prevádzkovateľa a Používateľa týkajúce sa poskytnutia Služieb Aplikácie;",
                articleNumberTwo: "Článok II.",
                rulesOfApp: "Pravidlá a podmienky používania Aplikácie",
                thisVopEdits: "Tieto VOP upravujú ",
                rulesOfUse: "podmienky a pravidlá používania Aplikácie a ",
                lawBetween: " vzájomné práva a povinnosti medzi Prevádzkovateľom a Používateľom založené Zmluvou o poskytnutí služieb.",
                appNotFor: "Aplikácia nie je určená pre Spotrebiteľa. Spotrebiteľovi sa zakazuje používať Aplikáciu.",
                flawless: "Prevádzkovateľ nikomu negarantuje nepretržitú funkčnosť Aplikácie a ani bezchybnú činnosť Aplikácie.",
                operatorIsNot: "Prevádzkovateľ nie je povinný poskytovať Služby Aplikácie okamžite, nepretržite alebo bez výpadkov.",
                everybodyUse: "Každý, kto používa Aplikáciu, má povinnosti Používateľa vyplývajúce z týchto VOP a z právnych predpisov právne záväzných v Slovenskej republike.",
                everybodyHaveTo: "Každý je povinný pri používaní Aplikácie dodržiavať povinnosti Používateľa vyplývajúce z týchto VOP a z právnych predpisov právne záväzných v Slovenskej republike.",
                everybodyCould: "Každý je oprávnený používať Aplikáciu výlučne len v používateľskom rozhraní Aplikácie.",
                onlyAdmin: "Prevádzkovateľ zabezpečuje admin rozhranie Aplikácie proti náhodnému vstupu/preniknutiu tretích osôb; do admin rozhrania Aplikácie má prístup len IT admin.",
                nobodyBesidesAdmin: "Všetkým sa zakazuje vstupovať do admin rozhrania Aplikácie.",
                appPurpose: "Účelom Aplikácie je výlučne len uzatvorenie Zmluvy o poskytnutí služieb, poskytovanie Služieb Aplikácie a zabezpečenie zaplatenia Ceny za poskytnutie Služieb Aplikácie.",
                appOnlyForSale: "Používateľ je povinný používať Aplikáciu len za účelom kúpenia Služieb Aplikácie a zaplatenia Ceny za poskytnutie Služieb Aplikácie.",
                userUsingApp: "Používateľ a osoba konajúca v mene Používateľa pri používaní Aplikácie, sú v plnom rozsahu a bez akýchkoľvek obmedzení, spoločne a nerozdielne zodpovední Prevádzkovateľovi za škodu spôsobenú porušením povinností Používateľa vyplývajúcich z týchto VOP.",
                userAccept: "Používateľ používaním Aplikácie tieto VOP akceptuje, zaväzuje sa nimi riadiť a zaväzuje sa korektne dodržiavať všetky povinnosti vyplývajúce Používateľovi z týchto VOP.",
                usingAppToBuy: "Používanie Aplikácie, kúpenie Služieb Aplikácie a zaplatenie Ceny za poskytnutie Služieb Aplikácie, sú podmienené prístupom na internet. Prístup na internet nie je súčasťou Aplikácie ani súčasťou Služieb Aplikácie.",
                operatorCan: "Prevádzkovateľ nie je zodpovedný za žiadne obmedzenia používania Aplikácie, za žiadne vady Služieb Aplikácie a za žiadne vady platenia Ceny za poskytnutie Služieb Aplikácie, ktoré sú spôsobené nestálosťou internetového pripojenia Používateľa a/alebo akoukoľvek inou technickou nedostatočnosťou internetového pripojenia Používateľa a/alebo akoukoľvek technickou nedostatočnosťou Zariadenia Používateľa a/alebo Aplikáciou.",
                operatorDont: "Prevádzkovateľ nie je zodpovedný za žiadne škody spôsobené Používateľovi v súvislosti s používaním Aplikácie ani v súvislosti s poskytovaním Služieb Aplikácie ani v súvislosti s platením Ceny za poskytnutie Služieb Aplikácie, ktoré boli Používateľovi spôsobené nestálosťou internetového pripojenia Používateľa a/alebo akoukoľvek inou technickou nedostatočnosťou internetového pripojenia Používateľa a/alebo akoukoľvek technickou nedostatočnosťou Zariadenia Používateľa a/alebo Aplikáciou.",
                operatorAndRisk: "Prevádzkovateľ nikomu nezodpovedá za žiadnu nepriamu, náhodnú, následnú, mimoriadnu, trestnú a/alebo podobnú škodu, vrátane [najmä, nie však výlučne] zodpovednosti za stratu príjmu, stratu zisku, stratu dát alebo prevádzkové poruchy (prerušenie prevádzky) alebo za iné nehmotné straty (i keď takéto straty sú kvalifikované), ktoré vzniknú z/alebo akokoľvek súvisia s ",
                withThisVOP: "týmito VOP a/alebo",
                appService: "Službami Aplikácie a/alebo",
                appForContract: "Aplikáciou, či už na základe Zmluvy o poskytnutí služieb, úmyselného porušenia práva alebo na základe iného právneho titulu a bez ohľadu na to, či Prevádzkovateľ upozornil Používateľa [resp. či Používateľ bol upozornený] na možnosť takejto škody.",
                appPrice: "Používateľ používaním Aplikácie konkludentne ubezpečuje Prevádzkovateľa, že Používateľovi nevznikajú žiadne náklady vyvolané používaním Aplikácie, najmä žiadne osobitné náklady za použitie komunikačných prostriedkov na diaľku.",
                userRespects: "Používateľ je pri používaní Aplikácie povinný rešpektovať práva a oprávnené záujmy Prevádzkovateľa, najmä pri nakladaní s autorskými dielami a inými predmetmi práva duševného vlastníctva.",
                userCant: "Používateľovi sa zakazuje používať Aplikáciu takým spôsobom, ktorý spôsobí porušenie Aplikácie a/alebo obmedzenie prevádzky Aplikácie a/alebo obmedzenie funkčnosti Aplikácie.",
                userCantOne: "Používateľovi sa zakazuje akýmkoľvek spôsobom zasahovať do Aplikácie alebo jej častí, meniť, kopírovať a/alebo rozširovať vzhľad, grafické prvky, rozhranie, technický charakter a ďalšie vlastnosti Aplikácie.",
                userCantTwo: "Používateľovi sa zakazuje sprístupňovať Aplikáciu tretím osobám.",
                userCantThree: "Používateľovi sa zakazuje prostredníctvom Aplikácie poskytovať služby tretím osobám.",
                userHaveTo: "Používateľ je povinný zabezpečiť, aby v prípade zneužívania alebo podozrenia zo zneužívania Aplikácie boli vykonané všetky potrebné úkony smerujúce k upusteniu od takéhoto stavu alebo od činností porušujúcich právne predpisy alebo zmluvné dojednania medzi ním a Prevádzkovateľom, a tiež bezodkladne odstrániť všetky následky takýchto činností a zásahov do oprávnených záujmov Prevádzkovateľa; tým nie je dotknutá zodpovednosť Používateľa za škodu spôsobenú Prevádzkovateľovi.",
                userCould: "Používateľ je oprávnený objednať si u Prevádzkovateľa Služby Aplikácie uzatvorením Zmluvy o poskytovaní služieb.",
                isForbidden: "Používateľovi je pri používaní Aplikácie zakázané:",
                useProfanity: "používať vulgarizmy, slovné spojenia a/alebo slovné alebo znakové výrazy, ktorých priamy alebo nepriamy význam je v rozpore so všeobecne akceptovateľnou spoločenskou morálkou a dobrými mravmi,",
                useReservations: "používať vyhrážky a osobné útoky voči Prevádzkovateľovi, iným Používateľom alebo akýmkoľvek tretím osobám,",
                useLies: "uvádzať nepravdivé, neoverené, zavádzajúce, urážlivé alebo klamlivé informácie o inej osobe,",
                useViolence: "propagovať násilie a otvorene alebo skrytou formou podnecovať k nenávisti na základe pohlavia, rasy, farby pleti, jazyka, viery a náboženstva, politického či iného zmýšľania, národného alebo sociálneho pôvodu, príslušnosti k národnosti alebo k etnickej skupine alebo na základe akéhokoľvek iného dôvodu,",
                useWar: "propagovať vojnu alebo opisovať kruté alebo inak neľudské konanie spôsobom, ktorý je ich nevhodným zľahčovaním, ospravedlňovaním alebo schvaľovaním,",
                useAlcohol: "otvorene alebo skrytou formou propagovať alkohol, alkoholizmus, fajčenie, užívanie omamných látok, jedov a prekurzorov alebo zľahčovať následky užívania uvedených látok,",
                useFear: "ohrozovať fyzický, psychický alebo morálny vývin maloletých alebo narúšať ich duševné zdravie a emocionálny stav,",
                useChildPornography: "propagovať detskú pornografiu,",
                useBadTexts: "zverejňovať nezmyselné alebo nezrozumiteľné texty, ako aj vykonávať iné aktivity, ktoré môžu čo i len potenciálne viesť k obmedzeniu alebo zníženiu kvality Aplikácie a/alebo k obmedzeniu alebo zníženiu kvality poskytovaných Služieb Aplikácie,",
                usePrivateInfo: "zverejňovať osobné údaje o iných osobách, najmä ich meno, priezvisko, adresu alebo telefónne číslo, pokiaľ k tomu uvedená osoba neudelila súhlas,",
                shareReservations: "šíriť obscénne, vulgárne a urážlivé materiály a protizákonné materiály, pričom zakázané je aj zverejňovať odkaz na akékoľvek webové stránky s takýmto obsahom,",
                takeUserInfo: "získavať prihlasovacie mená a/alebo heslá iných Používateľov,",
                editApp: "zneužívať, blokovať, modifikovať alebo inak meniť, upravovať akúkoľvek súčasť Aplikácie, alebo sa čo len pokúsiť narušiť stabilitu, integritu, chod alebo dáta Aplikácie,",
                hackApp: "používať mechanizmy, programové vybavenie alebo iné postupy, ktoré by mohli mať negatívny vplyv na prevádzku Aplikácie,",
                shareCompetition: "zverejňovať akékoľvek informácie, ktoré svojím obsahom môžu naplniť znaky nekalej súťaže podľa ustanovenia § 44 – 51 zákona č. 513/1991 Zb. Obchodný zákonník v znení neskorších predpisov,",
                shareCommercial: "zverejňovať akúkoľvek reklamu alebo propagáciu výrobkov, tovarov alebo služieb.",
                articleThree: "Článok III.",
                contractOfProvision: "Zmluva o poskytnutí služieb",
                finishOrderMoment: "Dokončením objednávky nastáva okamih, kedy je medzi Prevádzkovateľom a Používateľom uzatvorená Zmluva o poskytnutí služieb.",
                acceptVOP: "Používateľ vyhlasuje, že sa pred uzatvorením Zmluvy o poskytnutí služieb dôkladne a detailne oboznámil so znením Zmluvy o poskytnutí služieb a so znením týchto VOP.",
                userAcceptContract: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje, že ustanovenia Zmluvy o poskytnutí služieb a ustanovenia VOP sú mu zrozumiteľné a jasné.",
                partOfContractIsVOP: "Neoddeliteľnou súčasťou Zmluvy o poskytnutí služieb sú tieto VOP.",
                contractIsActive: "Zmluva o poskytnutí služieb je platná a záväzná aj pre právnych nástupcov Prevádzkovateľa a pre právnych nástupcov Používateľa.",
                userAcceptActiveContract: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje, že Prevádzkovateľ nie je povinný preveriť ani žiadnym spôsobom skontrolovať údaje uvádzané Používateľom v objednávkovom formulári Aplikácie, najmä Prevádzkovateľ nie je povinný skontrolovať či sa nejedná o neexistujúcu/nefungujúcu/nesprávnu/neplatnú e-mailovú adresu osoby konajúcej v mene Používateľa a/alebo či sa nejedná o neexistujúce/nefungujúce/nesprávne/neplatné mobilné telefónne číslo osoby konajúcej v mene Používateľa.",
                userCloseContract: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje, že Prevádzkovateľ nie je povinný preveriť ani žiadnym spôsobom skontrolovať Údaje vyplnené Používateľom.",
                operatorAccept: "Prevádzkovateľ nikomu negarantuje, že Údaje vyplnené Používateľom je možné zapísať do Obchodného registra SR.",
                operatorInform: "Prevádzkovateľ oznamuje Používateľovi a Používateľ berie na vedomie skutočnosť, že uzatvorením Zmluvy o poskytnutí služieb Používateľ záväzne žiada Prevádzkovateľa o bezodkladné začatie poskytovania Služieb Aplikácie.",
                userAcceptService: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje, že pred uzavretím Zmluvy o poskytnutí služieb ho Prevádzkovateľ prostredníctvom Aplikácie riadne a v dostatočnom rozsahu oboznámil s predpokladaným rozsahom právnych úkonov, ktoré je potrebné uskutočniť na poskytnutie Služieb Aplikácie v rozsahu Používateľovej objednávky.",
                operatorAutomaticaly: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje skutočnosť, že Prevádzkovateľ automaticky začína poskytovať Používateľovi Služby Aplikácie okamihom uzatvorenia Zmluvy o poskytnutí služieb, ešte pred zaplatením Ceny.",
                operatorOnline: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje, že Používateľ využil možnosť online zistiť chybu/nedostatok/nesprávnosť Údajov vyplnených Používateľom ",
                controllData: "prednostne preverením správnosti a úplnosti údajov vyplnených Používateľom v Aplikácii a",
                controllText: "kontrolou textu Dokumentu v používateľskom rozhraní Aplikácie.",
                onlyInApp: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje, že dopĺňanie a/alebo opravovanie chýb/nedostatkov/nesprávností Údajov vyplnených Používateľom, je možné vykonať výlučne len v používateľskom rozhraní Aplikácie pred Dokončením objednávky.",
                editDocument: "Používateľ uzatvorením Zmluvy o poskytnutí služieb konkludentne potvrdzuje, že Vygenerované Dokumenty je z technických dôvodov objektívne nemožné editovať [t.j. najmä meniť, dopĺňať, vymazávať a pod.].",
                incidentsFromContract: "Povinnosť Prevádzkovateľa Doručiť Vygenerované Dokumenty Používateľovi zakotvená v Zmluve o poskytnutí služieb, vyvoláva právne účinky až okamihom zaplatenia Ceny. Používateľ berie na vedomie a výslovne súhlasí s tým, že Prevádzkovateľ nie je povinný Používateľovi Doručiť Vygenerované Dokumenty skôr, než Používateľ zaplatí Prevádzkovateľovi Cenu.",
                goodPrice: "Používateľ potvrdzuje, že Cenu považuje za zodpovedajúcu poskytovaným Službám Aplikácie a že takto dohodnutú Cenu nepovažuje za odporujúcu dobrým mravom.",
                afterOrderFinish: "Po Dokončení objednávky je Používateľ Aplikáciou presmerovaný na zabezpečenú platobnú bránu Aplikácie za účelom zaplatenia Ceny.",
                userAcceptPay: "Používateľ je povinný zaplatiť Prevádzkovateľovi Cenu výlučne len použitím zabezpečenej platobnej brány Aplikácie; použitie iných spôsobov platby nemá za následok splnenie povinnosti Používateľa zaplatiť Prevádzkovateľovi Cenu.",
                threeTimes: "Na zaplatenie Ceny použitím zabezpečenej platobnej brány Aplikácie má Používateľ tri [3] pokusy.",
                afterPay: "Proti pohľadávke Prevádzkovateľa na zaplatenie Ceny nie je možné započítať žiadnu pohľadávku Používateľa voči Prevádzkovateľovi ani žiadnu pohľadávku tretej osoby voči Prevádzkovateľovi.",
                paymentDocument: "Prevádzkovateľ vystaví Používateľovi riadnu faktúru podľa rozsahu poskytnutých Služieb Aplikácie. Súčasťou faktúry je špecifikácia poskytnutých Služieb Aplikácie.",
                serviceTax: "Používateľ týmto vyslovuje v zmysle § 71 ods. 1 písm. b) zákona č. 222/2004 Z. z. o dani z pridanej hodnoty súhlas s vydaním elektronickej faktúry. Faktúra sa doručuje Používateľovi výlučne len elektronicky zaslaním na e-mailovú adresu zadanú Používateľom do objednávkového formulára Aplikácie pri Dokončení objednávky. Prevádzkovateľ odošle Používateľovi faktúru bezodkladne po zaplatení Ceny. Faktúra sa považuje za doručenú Používateľovi okamihom odoslania faktúry na e-mailovú adresu zadanú Používateľom do objednávkového formulára Aplikácie pri Dokončení objednávky. Validné Doručenie faktúry Používateľovi nastane aj vtedy, ak Používateľ v objednávkovom formulári Aplikácie uvedie neexistujúcu/nefungujúcu/nesprávnu/neplatnú e-mailovú adresu.",
                noInterest: "Prevádzkovateľ a Používateľ sa dohodli, že Prevádzkovateľ nie je povinný po skončení poskytovania Služieb Aplikácie odovzdať Používateľovi protokolárne, osobne ani nijak inak spisovú agendu, nakoľko Používateľ má záujem len o Doručenie Vygenerovaných Dokumentov a okrem toho Používateľ nemá žiaden záujem o spisovú agendu.",
                operatorAcceptLaw: "Prevádzkovateľ sa pri poskytovaní Služieb Aplikácie riadi právnymi predpismi právne záväznými v Slovenskej republike a záväznými predpismi a usmerneniami Slovenskej advokátskej komory.",
                contractCancel: "Zmluva o poskytnutí služieb sa automaticky zrušuje márnym uplynutím tretieho pokusu Používateľa o zaplatenie Ceny použitím zabezpečenej platobnej brány Aplikácie; takéto zrušenie Zmluvy o poskytnutí služieb má za následok",
                contractCancelOne: " stratu všetkých údajov vyplnených Používateľom v Aplikácii a ",
                contractCancelTwo: "presmerovanie Používateľa na domovskú stránku Aplikácie.",
                operatorAfterContract: "Nároky Prevádzkovateľa vyplývajúce zo Zmluvy o poskytnutí služieb nezanikajú ani po zániku Zmluvy o poskytnutí služieb.",
                articleNumberFour: "Článok IV.",
                responsibility: "Zodpovednosť za obsah Vygenerovaných Dokumentov",
                makeLawPart: "Prevádzkovateľ je povinný vytvoriť Právnu časť Dokumentu tak, aby v rozsahu Používateľom zvolenej objednávky Služieb Aplikácie, Vygenerované Dokumenty obsahovali všetky podstatné náležitosti právne relevantné pre konanie vo veciach obchodného registra podľa Civilného mimosporového poriadku.",
                deleteOne: "Prevádzkovateľ si vyhradzuje právo kedykoľvek zmazať obsah Údajov vyplnených Požívateľom,",
                deleteTwo: "ktorý porušuje ustanovenia Článku II. bod 30 týchto VOP alebo",
                deleteThree: "pri ktorom je podozrenie, že by čo i len potenciálne mohol porušovať tieto VOP.",
                operatorTakes: "Prevádzkovateľ si vyhradzuje právo:",
                partTime: "dočasne alebo natrvalo, v celom rozsahu alebo čo i len čiastočne prerušiť možnosť zadania Údajov vyplnených Používateľom;",
                anyTime: "kedykoľvek vykonať technickú odstávku Aplikácie, a to aj bez akéhokoľvek predchádzajúceho upozornenia,",
                without: "bez obmedzení vykonávať akékoľvek práva, ktoré Prevádzkovateľovi vyplývajú z týchto VOP alebo z právnych predpisov právne záväzných v Slovenskej republike.",
                userDontTake: "Prevádzkovateľ nezodpovedá za správnosť/pravdivosť/úplnosť Údajov vyplnených Používateľom.",
                userAcceptResponsibility: "Používateľ prijíma výhradnú plnú zodpovednosť za ním uskutočnené konanie pri používaní Aplikácie, najmä pri zvolení, používaní, nastavení a zadaní Údajov vyplnených Používateľom.",
                content: "Zadanie obsahu Údajov vyplnených Používateľom neznamená, že sa Prevádzkovateľ stotožňuje s ich obsahom, správnosťou, pravdivosťou a/alebo úplnosťou.",
                artivleNumberFive: "Článok V.",
                lawOfAuthor: "Právo duševného vlastníctva",
                author: "Aplikácia je autorským dielom, ku ktorému majetkové práva vykonáva Prevádzkovateľ a je chránená predovšetkým Autorským zákonom a ďalšími príslušnými právnymi predpismi právne záväznými v Slovenskej republike.",
                operatorProperty: "Prevádzkovateľ má všetky majetkové práva k Aplikácii a výlučne Prevádzkovateľ je oprávnený poskytnúť súhlas/licenciu na používanie Aplikácie. Podmienky používania Aplikácie určuje, vydáva a mení výhradne Prevádzkovateľ.",
                operatorCanUse: "Prevádzkovateľ umožňuje Používateľovi používanie Aplikácie výlučne len pre osobné a nekomerčné potreby Používateľa. Akceptáciou týchto VOP Používateľ súhlasí, že nebude používať žiadne Služby Aplikácie za iným účelom ako je uvedený v predchádzajúcej vete. Doručením Vygenerovaných Dokumentov končí oprávnenie Používateľa na používanie Aplikácie.",
                cantAnalyse: "Používateľ nie je oprávnený Aplikáciu analyzovať, meniť, upravovať a dopĺňať, rozmnožovať, spracovávať, upravovať, distribuovať, vyhotovovať preklad Aplikácie zo strojového kódu do zdrojového jazyka, ani voľne modifikovať, ani adaptovať Aplikáciu podľa svojej potreby, a to ani prostredníctvom tretích osôb.",
                noCopy: "Používateľ nie je oprávnený vyhotoviť záložnú rozmnoženinu Aplikácie, a to ani prostredníctvom tretích osôb, nakoľko takáto rozmnoženina Aplikácie nie je potrebná pre fungovanie Aplikácie ani pre používanie Aplikácie.",
                cantTest: "Používateľ nie je oprávnený preskúmať ani testovať funkčnosť Aplikácie za účelom zistenia princípov, na ktorých bola Aplikácia založená a vytvorená, ani za účelom zistenia princípov, na ktorých bol založený a vytvorený ktorýkoľvek prvok Aplikácie. Porušenie VOP podľa tohto bodu Používateľom je dôvodom na okamžité zablokovanie Používateľa v Aplikácii, s čím Používateľ vyjadruje svoj výslovný a bezvýhradný súhlas. Nárok Prevádzkovateľa na náhradu škody voči Používateľovi nie je týmto dotknutý.",
                cantOwn: "Používateľ využívaním Aplikácie nenadobúda vlastnícke právo, ani žiadne majetkové ani osobnostné práva k Aplikácii, softvéru, ani k žiadnej ich súčasti.",
                userAndOperator: "Používateľ a Prevádzkovateľ sa týmto dohodli,",
                operatorOwn: "že akékoľvek údaje vložené Používateľom do databázy obsiahnutej v Aplikácii sú časťou databázy zhromaždenej Prevádzkovateľom a",
                databaseOwner: "že zriaďovateľom databázy je výhradne Prevádzkovateľ. Používateľovi nevzniká žiadne právo k databáze obsiahnutej v Aplikácii.",
                articleNumber: "Článok VI.",
                finalDecision: "Záverečné ustanovenia",
                userAgree: "Používateľ súhlasí ",
                userAgreeOne: " so spracovaním osobných údajov v rozsahu podľa Súhlasu so spracovaním osobných údajov a ",
                userAgreeTwo: "so spracovaním súborov cookies v rozsahu podľa Súhlasu so spracovaním súborov cookies.",
                lawOfState: "Tieto VOP sa riadia právnym poriadkom Slovenskej republiky. Právny vzťah medzi Prevádzkovateľom a Používateľom sa riadi právom Slovenskej republiky, predovšetkým Obchodným zákonníkom. Prípadné spory medzi Prevádzkovateľom a Používateľom budú rozhodované vecne a miestne príslušným súdom podľa sídla Prevádzkovateľa.",
                changeVOP: "Prevádzkovateľ si vyhradzuje právo na zmenu týchto VOP. Zmena VOP je platná a účinná dňom uvedeným vo VOP. Prevádzkovateľ zverejní nové VOP umiestnením na Internetovej stránke.",
                userAndOperatorAccept: "Prevádzkovateľ a používateľ sa dohodli, že plne uznávajú elektronickú formu komunikácie prostredníctvom elektronickej pošty a internetovej siete ako platnú a záväznú pre obe zmluvné strany."
            },
            VotingImputBox: {
                voteYes: "Za",
                votingMaybe: "Zdržal sa",
                voteNo: "Proti",
                numberOfVotes: "Množstvo hlasov:",
                forChange: 'Ak sa tento spoločník nezúčastnil na hlasovaní o tomto bode programu, najskôr vypnite možnosť  "Na valnom zhromaždení boli prítomní všetci spoločníci", ktorú ste zaškrtli v úvodnom bode 2. s názvom "Ktorí spoločníci sa zúčastnili na valnom zhromaždení?"',
                forChangeTwo: 'Ak tento spoločník nehlasoval za prijatie rozhodnutia o tomto bode programu, najskôr vypnite možnosť "Všetci spoločníci hlasovali za schválenie všetkých bodov programu" v úvodnom v bode 2. s názvom "Ktorí spoločníci sa zúčastnili na valnom zhromaždení?"',
                here: "Zúčastnil sa",
                notImportant: "Na jeho hlasy sa neprihliada",
                voteCanOnly: "Hlasovať o tomto bode programu môže iba ten spoločník, ktorý sa zúčastnil na hlasovaní",
                forVote: 'Aby spoločník mohol hlasovať, musíte v úvodnom v bode 2. s názvom "Ktorí spoločníci sa zúčastnili na valnom zhromaždení?" napísať, koľko hlasov v % patrí tomuto spoločníkovi',
                forVoteInput: 'Aby spoločník mohol hlasovať, musíte v úvodnom v bode 2. s názvom "Ktorí spoločníci sa zúčastnili na valnom zhromaždení?" napísať, koľko hlasov v % patrí tomuto spoločníkovi',
                voting: "Hlasovanie",
                votingCount: "% hlasov.",
                accepted: "Uznesenie bolo prijaté",
                border: "Pre konanie VZ treba:",
                percents: "Pre schválenie treba:",
                herePeople: "% hlasov prítomných spoločníkov.",
                allPeople: "% hlasov všetkých spoločníkov.",
                noPeople: "Žiadny spoločníci",
                notRecognizable: "Valné zhromaždenie nie je uznášania schopné",
            },
            ZivnostNewBox: {
                remove: "Odobrať",
                enterRange: "Túto živnosť špecifikujte tak, ako je napísaná v doklade o odbornej kvalifikácií",
                range: "Prepíšte rozsah tejto živnosti z dokladu o odbornej kvalifikácií",
                activity: "Názov pridaného predmetu podnikania je",
                activityPlaceholder: "Napíšte presný názov",
                choose: "Chcem pridať živnosť",
                chooseButton: "Vyberte si zo zoznamu",
                orEnter: "Chcem pridať nie živnosť",
                add: "Napíšte predmet podnikania",
                chooseAcitivity: "Vyberte si zo zoznamu živnostenských oprávnení, ktoré eviduje živnostenský úrad",
            },
            CheckouFormBox: {
                street: "Ulica",
                city: "Mesto",
                zip: "PSČ",
                country: "Krajina",
                invoiceDocs: "Fakturačné údaje",
                makeInvoice: "Chcem fakturovať na inú firmu",
                company: "Názov spoločnosti",
                companyAdress: "Adresa sídla",
                dic: "DIČ",
                icdph: "IČ DPH",
                contactData: "Kontaktné údaje",
                nameSurname: "Meno a priezvisko",
                enterValidMail: 'Prosím zadajte platný email.',
                phone: "Telefónne číslo",
                enterValidPhone: "Prosím zadajte platné telefónne číslo.",
                docs: "Dokumentácia:",
                moenyFor: "Odmena za vyhotovenie dokumentácie",
                representing: "Zastupovanie:",
                moneyForRepresenting: "Odmena za zastupovanie",
                withoutWat: "Spolu bez DPH",
                with20Wat: "DPH 20%",
                fees: "Súdne a správne poplatky:",
                courtFee: "Súdny poplatok",
                sendingFee: "Dobropisovaná suma",
                finalAmount: "Konečná suma",
                acceptTips: "Akceptujem rady a odporúčania právnika",
                iaccept: "Súhlasím so",
                universalRules: "všeobecnými obchodnými podmienkami",
                aboutContract: "zmluvou o poskytovaní služieb",
                campaignAgreement: "zasielaním marketingových kampaní",
                finishOrder: "Dokončiť objednávku s povinnosťou platby",
                enterPassword: "Zadajte heslo pre registráciu, alebo sa prihláste",
                weakPassword: "Heslo musí obsahovať aspoň jedno velké a malé písmeno, aspoň jednu číslicu a aspoň jeden špeciálny znak: '!@#$%^&*)(+=._-'",
                cognitoErrorUserExists: 'Užívateľ s daným menom už existuje, použite iný email.'
            },
            LoadOrderModalBox: {
                password: "Heslo k formuláru",
                loadContent: "Načítať formulár",

            },
            LoginModalBox: {
                loading: "Načítavam ...",
                loginRegister: "Prihlásenie / Registrácia",
                login: "Prihlásiť",
                register: "Registrovať",
                forgot: "Zabudol som heslo",
                operator: "Portál prevádzkuje",
                youCanPayWith: "Na tejto stránke môžete bezpečne platiť cez:",
                rules: "Všeobecné obchodné podmienky",
                gdpr: "Ochrana osobných údajov",
                emailControll: "Váš email nebol overený, pre overenie zadajte kód ktorý ste obdržali emailom po registrácií.",
                controlCode: "Overovací kód",
                controll: "Overiť",
                resendEmail: "Pre opätovné odoslanie verifikačného emailu kliknite sem.",
                resend: "Znovu odoslať",
                forNewPass: "Pre obnovenie hesla zadajte email ktorý",
                youUsed: " ste použili pri registrácií",
                yourMail: "Váš e-mail",
                userName: 'Používateľské meno',
                sendCode: "Odoslať overovací kód",
                codeSms: "Pre overenie zadajte kód ktorý ste obdržali cez SMS.",
                resendSms: "Pre opätovné odoslanie verifikačnej SMS kliknite sem.",
                reControl: "Znovu odoslať",
                logOut: "Odhlásiť sa",
                myOrders: "Vytvorené zmluvy",
                password: 'Heslo'


            },
            OrderStatusFormBox: {
                orderStatus: "Stav objednávky",
                dateOfOrder: "Dátum doručenia",
                smallCompany: "Živnosť",
                numberOf: "Číslo podania",
                recieveDate: "Dátum podania",
                lawBuilding: "Úrad",
                chooseOffice: "Vyberte živnostenský úrad",
                court: "Súd",
                chooseCourt: "Vyberte súd",
                dateOfUrgent: 'Dátum urgovania',
                dateOfWrite: 'Dátum zapísania',
                saveOrder: "Uložiť objednávku",
                addFiles: "Pridaj súbory",
                addDateOfWrite: "Dátum zápisu",

            },
            PasswordResetFormBox: {
                resetPassword: "Obnovenie hesla",
                authCode: "Overovací kód",
                password: "Heslo",
                repeatPassword: "Zopakujte heslo pre registráciu",
                passwordArentSame: 'Heslá sa nezhodujú',

            },
            SaveOrderModalBox: {
                saveOrder: "Uložte si rozpracovaný dokument",
                pleaseSave: "Prosíme, zadajte e-mail, na ktorý zašleme odkaz na rozpracovaný dokument.",
                youCanComeBack: "Môžte sa k nemu kedykoľvek vrátit - ľahko a pohodlne.",
                yourMail: "Váš e-mail",
                yourSavedDoc: "Váš rozpracovaný formulár bol uložený v čase",
                updateDocs: "a bude aktualizovaný vždy, keď opustíte okno. Pre okamžité aktualizovanie údajov kliknite nižšie.",
                save: "Uložiť",
            },
            StepperBox: {
                flowOfMeet: "Názvy dokumentov",
                neededToBeFill: "Čo je potrebné vyplniť",
                viewOfDocs: "Náhľad pripravovaných dokumentov",
                firstStep: 'Vypĺňte údaje',
                secondStep: 'Platba za zmluvu',
                thirdStep: 'Vytvorená zmluva',
                fourthStep: 'Podpíšte online občianským',
            },
            UserProfileBox: {
                signatureRequests: "Žiadosti o podpis",
                billingInfo: "Fakturačné údaje",
                benefits: "Odteraz môžete využívať jeho výhody:",
                fastView: "Máte rýchly prehľad o svojich objednávkach",
                getAcces: "Získate prístup k ďalším výhodám",
                accept: "Rozumiem",
                logOut: "Odhlásiť sa",
                homePage: "Domovská stránka",
                actions: "Aktuálne akcie",
                myOrders: "Vytvorené zmluvy",
                progress: "Prehľad vygenerovných a rozpracovaných zmlúv",
                myDocuments: "Vytvorené / uložené zmluvy",
                actionsNow: "Aktuálne akcie",
                useActions: "Využite naše špeciálne akcie",
                specialPrice: "ÚČTOVNÁ ZÁVIERKA TERAZ LEN ZA 14,90€",
                weCanHelp: "Pomôžeme Vám, aby ste mali schválenie účtovnej závierky čo najľahšie a boli v kľude, bez pokút",
                OrderDocs: "Stačí, ak si u nás objednáte dokumenty potrebné na schválenie účtovnej závierky  a do 5 minút máte všetko potrebné vo Vašom e-maile.",
                offerEnds: "Ponuka platí do 31. augusta 2023.",
                iWantDocs: "Chcem účtovnú závierku",
                videoBlog: "Videonávody",
                preparing: "Pripravujeme ... ",

            },
            UserRegistrationBox: {
                surname: "Priezvisko",
                telephone: "Telefónne číslo",
                pleaseEnterFullNumber: "Prosím zadajte platné telefónne číslo.",
                iAgree: "Súhlasím so zasielaním marketingových kampaní",

            },
            UserOrderBox: {
                close: "Zatvoriť",
                open: "Otvoriť",
                download: "Stiahnuť",
                created: "Vytvorené",
                state: "Stav",
                numberInOffice: "Číslo podania úrad",
                dateInOffice: "Dátum podania úrad",
                office: "Úrad",
                addedToOffice: "Podatelňa úrad",
                dateOnCourt: "Dátum podania súd",
                court: "Súd",
                addedToCourt: "Podatelňa súd",
                urgentToOffice: "Urgované úrad",
                urgentToCourt: "Urgované súd",
                writtenToOffice: "Zapísané úrad",
                writtenToCourt: "Zapísané súd",

            },
            UserPersonsBox: {
                subscription: "Predplatné",
                title: "Moje šablóny osôb",
                menuTitle: "Moje šablóny osôb",
            },
            UserProfileSettingsBox: {
                given_name: "Meno",
                given_name_input: "Zadajte meno",
                family_name: "Priezvisko",
                family_name_input: "Zadajte priezvisko",
                email: "Email",
                email_input: "Zadajte email",
                phone_number: "Telefónne číslo",
                phone_number_input: "Zadajte elefónne číslo",
                marketing_suhlas: "Súhlasím so zasielaním marketingových ponúk.",
                unknownUser: "Neznámy používateľ",
                modalTitleGetBenefits: "PO UDELENÍ SÚHLASU ČERPAJTE SVOJE VÝHODY",
                modalTitleGetBenefitsThanks: "Ďakujeme za udelenie súhlasu, ktorý môžete kedykoľvek zrušiť po 30 dňoch. ",
            },
            PersonList: {
                createNewPerson: "Vytvoriť šablónu",
                name: "Meno osoby",
                surname: "Priezvisko osoby",
                address: "Adresa",
                enterNameAndSurname: 'Zadajte meno alebo priezvisko'
            },
            PersonEditBox: {
                personEditModalTitle: "Osobné údaje fyzickej osoby, ktorú chcem uložiť do šablóny",
                titlesBefore: "Tituly pred menom osoby sú",
                titlesAfter: "Tituly za menom osoby sú",
                name: "Meno osoby je",
                surname: "Priezvisko osoby je",
                idType: "Typ dokladu",
                documentId: "Číslo dokladu",
                dateOfBirth: "Vyberte dátum narodenia",
                documentType: 'Má osoba rodné číslo?',
                idNumber: 'Rodné číslo / identifikátor osoby je',
                uploadFile: "Nahrajte foto/scan OP alebo pasu a údaje sa automaticky vyplnia."
            },
            OrderListBox: {
                requester: "Žiadateľ",
                nameOfSro: "Názov zmluvy",
                ico: "IČO",
                feedBack: 'Hodnotenie',
                identifier: "Identifikátor",
                stateOfOrder: "Stav objednávky",
                stateOfPay: "Stav platby",
                priceOfOrder: "Celková suma objednávky",
                dateOfCreate: "Dátum vytvorenia",
            },
            UserListBox: {
                "username": "Cognito meno",
                "userstatus": "Stav užívateľa",
                "given_name": "Krstné meno",
                "family_name": "Priezvisko",
                "email": "Email",
                "email_verified": "Email overený",
                "phone_number": "Telefónne číslo",
                "phone_number_verified": "Telefónne číslo overené",
                "custom_marketing_suhlas": "Marketingový súhlas",
                "actions": "Operácie",
            },
            UserProcessForm: {
                "username": "Cognito meno",
                "userstatus": "Stav užívateľa",
                "given_name": "Krstné meno",
                "family_name": "Priezvisko",
                "email": "Email",
                "email_verified": "Email overený",
                "phone_number": "Telefónne číslo",
                "phone_number_verified": "Telefónne číslo overené",
                "customer_role": "Typ užívateľa",
                "custom_marketing_suhlas": "Marketingový súhlas",
                // "actions": "Operácie",
                "enterValue": "Zadajte hodnoty",
                "enterPassword": "Prosím vypľnte heslo!",
                "passwordValidation": "Heslo musí obsahovať aspoň jedno velké a malé písmeno, aspoň jednu číslicu a aspoň 8 znakov",
                "passwordDoNotMatch": "Heslá sa nezhodujú!"
            },
            FeedbackListBox: {
                companyName: "Nazov s.r.o.",
                contactName: "Kontakt meno",
                contactEmail: "Kontakt email",
                ratingValue: "Hodnotenie",
                ratingMessage: "Správa",
                ratingDate: "Dátum hodnotenia",
            },
            ErrorPageBox: {
                cantDo: "Ľutujeme, vybraný úkon nie je možné zrealizovať.",
                chooseAnotherCompany: "Vybrať inú firmu",
            },
            FrontOfficeBox: {
                cleanigDay: "bude prebiehať plánovaná údržba portálu. Ďakujeme za pochopenie | Tím MOJEZMLUVY.SK",
                day: "Dňa",

            },
            BaseInvestmentRaiseBox: {
                newInput: 'Záväzky na nové vklady prevezmú:',
                add: "Pridať",
                ico: 'IČO',
                birthID: 'Rodné číslo',
                idData: "Identifikačný údaj",
                enter: "Zadajte",
                owner: "vlastníka",
                birthIdOrId: 'Rodné číslo alebo identifikačný údaj',
                icoOrId: 'IČO alebo identifikačný údaj',
                chooseOwnerOne: 'Vyberte spoločníka',
                coOwner: "Spoločník",
                chooseBirthDate: "Vyberte dátum narodenia",
                chooseOwner: "Má spoločník",
                orData: "alebo iný identifikačný údaj?",
                localCourt: "Okresný súd",
                birthDate: 'Dátum narodenia',
                enterLocalCourt: "Zadajte okresný súd",
                part: "Oddiel",
                insert: "Vložka",
                enterPart: "Zadajte oddiel",
                enterInsert: "Zadajte vložku",
                remove: "Odobrať",
                enterRepresentMan: "Pridať zastupujúcu osobu",
                enterAmount: 'Záväzok na nový vklad do ZI je vo výške',
                enterAmountEUR: 'Po navýšení bude vklad spoločníka do ZI vo výške €',
                represent: 'Splnomocnenec',
                enterFunc: 'Napíšte jeho funkciu',
                func: "Funkcia",
                enterName: 'Napíšte meno',
                nameTitleSurname: "Titul, meno, priezvisko"
            },
            BaseInvestmentRaiseFromProfitComponentBox: {
                add: "Pridať",
                partsOfOwners: 'Podiely spoločníkov na základnom imaní sa zmenia následovne:',
                chooseOwner: 'Vyberte spoločníka',
                owner: "Spoločník",
                ofOwner: "vlastníka",
                ico: 'IČO',
                birthIdOrId: 'Rodné číslo alebo identifikačný údaj',
                icoOrId: 'IČO alebo identifikačný údaj',
                newAmount: 'Zadajte novú výšku podielu v EUR',
                idData: "Identifikačný údaj",
                birthId: 'rodné číslo',
                enter: "Zadajte",
                chooseIfOwner: "Má spoločník",
                addRepresentMan: "Pridať zastupujúcu osobu",
                orData: "alebo iný identifikačný údaj?",
                dateOfBirth: 'Dátum narodenia',
                enterLocalCourt: "Zadajte okresný súd",
                localCourt: "Okresný súd",
                enterPart: "Zadajte oddiel",
                part: "Oddiel",
                enterInsert: "Zadajte vložku",
                insert: "Vložka",
                remove: "Odobrať",
                representMan: 'Splnomocnenec',
                enterFunc: 'Napíšte jeho funkciu',
                func: "Funkcia",
                enterName: 'Napíšte meno',
                nameTitle: "Titul, meno, priezvisko",
            },
            DepositAdministratorBox: {
                chooseAdmin: 'Kto je správcom vkladov?',
                chooseAdminTooltip: 'Vyberte spoločníka ktorý spravuje vklady spoločníkov do základného imania spoločnosti do zápisu spoločnosti do obchodného registra.',
                chooseOwner: "vyberte spoločníka",
                enteBusinessName: "Zadajte Obchodné meno",
                businessName: 'Obchodné meno',
                businessAdress: "Zadajte sídlo",
                streetPSC: 'ulica č., PSČ, mesto',
                chooseCountry: 'Vyberte krajinu',
                country: "Krajina",
                ico: 'IČO',
                representMan: 'Splnomocnenec',
                enterFunc: 'Napíšte jeho funkciu',
                func: "Funkcia",
                enterName: 'Napíšte meno',
                nameTitle: "Titul, meno, priezvisko",
                enterRepresent: "Pridať splnomocnenca",
            },
            DozornaRadaComponentBox: {
                titlesBefore: "Tituly pred menom člena dozornej rady sú",
                titlesAfter: "Tituly za menom člena dozornej rady sú",
                firstName: "Meno člena dozornej rady je",
                lastName: "Priezvisko člena dozornej rady je",
                birthId: "Má člen dozornej rady rodné číslo?",
                birthIdPlaceholder: "vyberte rodné číslo alebo iný identifikačný údaj",
                birthIdTooltip: "V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.",
                enterBirthId: "Rodné číslo / identifikátor člena dozornej rady je",
                enterBirthIdPlaceholder: "napíšte rodné číslo alebo iný identifikačný udaj",
                enterBirthIdTooltip: "V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.",
                member: "Členom dozornej rady je",
                memberTooltip: "Je potrebné správne napísať celé meno a priezvisko člena dozornej rady, a prípadne aj všetky jeho tituly",
                address: "Bydlisko člena dozornej rady je",
                addressTooltip: 'Je potrebné správne a dostatočne presne špecifikovať adresu bydliska člena dozornej rady',
                sepervisoryMember: "Má člen dozornej rady",
                orIdentity: "alebo iný identifikačný údaj?",
                enterIdentity: "Zadajte identifikačný údaj",
                enterBirth: "Vyberte dátum narodenia",
                birth: 'Dátum narodenia',
                enterFunc: 'Napíšte jeho funkciu',
                func: "Funkcia",
                addMember: "Pridať člena dozornej rady",
                sepervisoryExists: "Výber voliteľných orgánov spoločnosti",
                sepervisoryExistsTooltip: "Dozorná rada obvykle nie je v spoločnostiach s ručením obmedzeným zriaďovaná, ak je zriadená slúži na kontrolu konateľov a účtovníctva."
            },
            KonateliaEstablishmentBox: {
                titlesBefore: "Tituly pred menom konateľa sú",
                titlesAfter: "Tituly za menom konateľa sú",
                firstName: "Meno konateľa je",
                lastName: "Priezvisko konateľa je",
                konatel: "Konateľom je",
                konatelTooltip: "Je potrebné správne napísať celé meno a priezvisko konateľa, a prípadne aj všetky jeho tituly",
                enterAdress: 'Bydlisko konateľa je',
                enterAdressTooltip: 'Je potrebné správne a dostatočne presne špecifikovať adresu bydliska konateľa',
                chooseIf: "Má konateľ rodné číslo?",
                chooseIfPlaceholder: "vyberte rodné číslo alebo iný identifikačný údaj",
                chooseIfTooltip: "V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.",
                enterBirthID: 'Rodné číslo / identifikátor konateľa je',
                enterBirthIDTooltip: 'V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.',
                enterData: "Napíšte identifikačný údaj",
                enterICO: 'Zadajte IČO',
                ICO: 'IČO',
                birthID: 'Rodné číslo',
                identication: "napíšte obchodné meno konateľa",
                chooseBirthDate: "Vyberte dátum narodenia",
                birthDate: 'Dátum narodenia',
                addOwner: "Pridať konateľa",
                removeOwner: "Odobrať konateľa",
            },
            OwnersComponentBox: {
                allPeopleMeet: 'Na valnom zhromaždení sa zúčastnili všetci spoločníci',
                allPeopleVotedForOne: 'Všetci spoločníci hlasovali za schválenie všetkých bodov programu',
                partOwner: "Spoločník",
                present: 'Zúčastnil sa',
                choosePersonType: 'Je to človek?',
                personType: "Typ osoby",
                individual: "Človek",
                legalPerson: "Právnická osoba",
                szco: "SZČO",
                enterVotes: 'Podiel hlasov v %',
                enterCompanyName: 'Obchodné meno spoločníka',
                enterName: 'Meno a priezvisko spoločníka',
                name: "Napíšte meno",
                enterAdress: 'Sídlo spoločníka',
                enterCompanyAdress: 'Bydlisko spoločníka',
                savedPersonsButton: 'Vybrať z uložených osôb',
                savedPersonsButtonAlternate: 'Vybrať z uložených osôb',
                savePerson: "Uložiť osobu",
                personInformation: "Identifikačné údaje osoby",
                searchPerson: "Vyhľadať osobu",
                enterNameAndSurname: "Zadajte meno alebo identifikačný údaj",
                personName: "Meno",
                personSurname: "Priezvisko",
                id: "Identifikačný údaj",
                searchOrsr: "Vyhľadať v ORSR",
                searchZrsr: "Vyhľadať v ZRSR",
                uploadImageForScanning: "Nahrať/Odfotiť doklad",
                uploadImageForScanningTooltip: "Nahrajte foto/scan OP alebo pasu a údaje sa automaticky vyplnia.",
            },
            OwnersEstablishmentBox: {
                titlesBefore: "Tituly pred menom osoby sú",
                titlesAfter: "Tituly za menom osoby sú",
                firstName: "Meno osoby je",
                lastName: "Priezvisko osoby je",
                shareCapital: 'Aká bude hodnota základného imania v €',
                choosePersonType: 'Je to človek?',
                owner: "Obchodné meno",
                personType: "Typ osoby",
                individual: "Človek",
                legalPerson: "Právnická osoba",
                depositeEuro: 'Zadajte vklad v €',
                paidDepositeEuro: 'Zadajte splatený vklad v €',
                shareCompanyPart: 'Zadajte podiel na spoločnosti v %',
                shareProfit: 'Zadajte podiel na zisku v %',
                enterBusinessName: 'Je potrebné správne napísať celé aktuálne obchodné meno',
                enterTitleNameTooltip: 'Je potrebné správne napísať celé meno a priezvisko spoločníka, a prípadne aj všetky jeho tituly',
                enterTitleName: 'Napíšte jeho/jej titul, meno, priezvisko',
                businessName: 'Obchodné meno',
                titleName: 'Titul, meno a priezvisko',
                partnerForeginer: "Je spoločník zahraničnou osobou?",
                depositManager: "Je tento spoločník správcom vkladov?",
                partnerExecutive: "Je tento spoločník zároveň aj konateľom?",
                enterHomeLocation: 'Sídlo spoločníka je',
                enterHomeLocationTooltip: 'Je potrebné správne a dostatočne presne špecifikovať aktuálnu adresu sídla spoločníka',
                enterCompanyAdress: 'Bydlisko spoločníka je',
                enterCompanyAdressTooltip: 'Je potrebné správne a dostatočne presne špecifikovať adresu bydliska spoločníka',
                ownerHaveBirthId: "Má osoba rodné číslo?",
                ownerHaveOtherId: "Má spoločnosť IČO?",
                ICO: 'vyberte IČO',
                ICOTooltip: 'V niektorých krajinách neprideľujú právnickým osobám IČO, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.',
                birthID: 'vyberte rodné číslo',
                birthIDTooltip: 'V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.',
                orID: "alebo iný identifikačný údaj?",
                dataID: 'Identifikačný údaj',
                enterICO: 'IČO / identifikátor spoločnosti je',
                enterICOTooltip: 'V niektorých krajinách neprideľujú právnickým osobám IČO, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.',
                enterICOPlaceholder: 'napíšte IČO alebo iný identifikačný udaj',
                enterBirthID: 'Rodné číslo / identifikátor osoby je',
                enterBirthIDTooltip: 'V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.',
                enterBirthIDPlaceholder: 'napíšte rodné číslo alebo iný identifikačný udaj',
                enterID: 'Zadajte identifikačný údaj',
                chooseBirthDate: "Vyberte dátum narodenia",
                birthDate: 'Dátum narodenia',
                representMan: 'V mene spoločnosti bude podpisovať:',
                enterFunc: 'Z akej pozície?',
                func: "napr. konateľ"
            },
            EstablishmentSinglePerson: {
                titlesBefore: "Tituly pred menom osoby sú",
                titlesAfter: "Tituly za menom spoločníka sú",
                firstName: "Meno osoby je",
                lastName: "Priezvisko osoby je",
                shareCapital: 'Aká bude hodnota základného imania v €',
                choosePersonType: 'Je to človek?',
                personType: "Typ osoby",
                individual: "Človek",
                legalPerson: "Právnická osoba",
                enterBusinessName: 'Obchodné meno',
                enterBusinessNameTooltip: 'Je potrebné správne napísať celé aktuálne obchodné spoločníka',
                enterTitleName: 'Napíšte jeho/jej titul, meno, priezvisko',
                businessName: 'Obchodné meno',
                titleName: 'Titul, meno a priezvisko',
                partnerForeginer: "Je spoločník zahraničnou osobou?",
                depositManager: "Je tento spoločník zároveň aj správcom vkladov?",
                partnerExecutive: "Je tento spoločník zároveň aj konateľom?",
                enterHomeLocation: 'Bydlisko spoločníka je',
                enterCompanyAdress: 'Sídlo spoločníka je',
                enterCompanyAdressTooltip: 'Je potrebné správne a dostatočne presne špecifikovať aktuálnu adresu sídla spoločníka',
                enterHomeLocationTooltip: 'Je potrebné správne a dostatočne presne špecifikovať adresu bydliska spoločníka',
                ownerHaveBirthId: "Má osoba rodné číslo?",
                ownerHaveOtherId: "Má spoločník IČO?",
                ICO: 'vyberte IČO',
                ICOTooltip: 'V niektorých krajinách neprideľujú právnickým osobám IČO, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.',
                birthID: 'vyberte rodné číslo',
                birthIDTooltip: 'V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.',
                orID: "alebo iný identifikačný údaj?",
                dataID: 'Identifikačný údaj',
                enterICO: 'IČO / identifikátor spoločnosti je',
                enterICOPlaceholder: 'napíšte IČO alebo iný identifikačný udaj',
                enterICOTooltip: 'V niektorých krajinách neprideľujú právnickým osobám IČO, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.',
                enterBirthID: 'Rodné číslo / identifikátor osoby je',
                enterBirthIDPlaceholder: 'napíšte rodné číslo alebo iný identifikačný udaj',
                enterBirthIDTooltip: 'V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.',
                enterID: 'Zadajte identifikačný údaj',
                chooseBirthDate: "Vyberte dátum narodenia",
                birthDate: 'Dátum narodenia',
                representMan: 'V mene spoločníka bude podpisovať: ',
                enterFunc: 'Z akej pozície?',
                func: "napr. konateľ",
                addRepresent: "Pridať zastupujúcu osobu",
                owner: "Obchodné meno",
                enterTitleNameTooltip: 'Je potrebné správne napísať celé obchodné meno spoločnosti',
            },
            SingleOwnerBox: {
                chooseOneType: 'Je jediný spoločník človek?',
                personType: "Typ osoby",
                individual: "Človek",
                legalPerson: "Právnická osoba",
                enterOneOwnerCompanyName: 'Zadajte obchodné meno jediného spoločníka',
                enterOwnerName: 'Zadajte meno jediného spoločníka',
                name: "Meno",
                enterOwnerLocation: 'Zadajte adresu sídlo jediného spoločníka',
                enterOwnerAdress: 'Zadajte adresu bydliska jediného spoločníka',
                ifOwnerHave: "Má spoločník",
                ICO: 'IČO',
                birthID: 'rodné číslo',
                orID: "alebo iný identifikačný údaj?",
                dataID: 'Identifikačný údaj',
                enterICO: 'Zadajte IČO',
                enterBirthID: 'Zadajte rodné číslo',
                enterID: 'Zadajte identifikačný údaj',
                chooseBirthDate: "Vyberte dátum narodenia",
                birthDate: 'Dátum narodenia',
                representMan: 'Splnomocnenec',
                enterFunc: 'Zadajte jeho funkciu',
                func: "Funkcia",
                addRepresent: "Pridať splnomocnenca",
                enter: "Zadajte",
                partner: "spoločníka",
                enterPartnerBirthDate: "Zadajte dátum narodenia spoločníka",
                enterTitleName: 'Zadajte titul, meno a priezvisko',
                titleName: 'Titul, meno a priezvisko',
            },
            RetributionBox: {
                withPayback: "Za kúpnu cenu",
                withoutPayback: "Bezodplatne",
                enterPaybackValue: "Výška kúpnej ceny je",
                paybackValue: "Výška kúpnej ceny",
                chooseExp: "Splatnosť kúpnej ceny je",
                exp: "Splatnosť",
                untilDate: "Do dátumu",
                withSign: "Pri podpise tejto zmluvy",
                chooseExpDate: "Vyberte dátum splatnosti",
                expDate: "Dátum splatnosti",
                choosePayment: "Vyberte spôsob platby",
                cash: "V hotovosti",
                transfer: "Prevodom na účet",
                didAccept: "Prevzal prevodca dojednanú odplatu?",
                iban: "IBAN"
            },
            PlnomocenstvoHeader: {
                enterFullOwner: "Zadajte splnomocňujúceho konateľa alebo prokuristu",
            },
            PresenceComponent: {
                personsHere: 'Prítomné osoby',
                personType: "Typ osoby"
            },
            PresenceKonatel: {
                chooseOwner: "Vyberte konatela",
                enterFunc: 'Zadajte jeho funkciu',
                func: "Funkcia",
                enterName: 'Zadajte meno',
                titleName: "titul, meno a priezvisko",
                enterAdress: 'Zadajte adresu',
                streetCity: "ulica č., PSČ, mesto",
                representMan: 'Zastupujúca osoba ',
            },
            PresenceOtherPerson: {
                enterFunc: 'Zadajte jeho funkciu',
                func: "Funkcia",
                enterName: 'Zadajte meno',
                titleName: "titul, meno a priezvisko",
                enterAdress: 'Zadajte adresu',
                streetCity: "ulica č., PSČ, mesto",
                representMan: 'Zastupujúca osoba ',
            },
            PresenceProkurista: {
                chooseProxy: "Vyberte prokuristu",
                proxy: "Prokurista",
                enterFunc: 'Zadajte funkciu',
                func: "Funkcia",
                enterName: 'Zadajte meno',
                titleName: "titul, meno a priezvisko",
                enterAdress: 'Zadajte adresu',
                streetCity: "ulica č., PSČ, mesto",
                isHeRpresent: "Zastupuje ho niekto?",
                enterRepresent: "Pridať splnomocnenca",
                representMan: 'Splnomocnenec',
                enterCountry: 'Vyberte krajinu',
                country: "Krajina",
            },
            PresentOwnerPerson: {
                coOwner: 'Spoločník',
                enterFunc: 'Zadajte funkciu',
                func: "Funkcia",
                enterName: 'Zadajte meno',
                titleName: "titul, meno a priezvisko",
                enterAdress: 'Zadajte adresu',
                streetCity: "ulica č., PSČ, mesto",
                isHeRpresent: "Zastupovaný inou osobou/osobami?",
                enterRepresent: "Pridať zastupujúcu osobu",
                representMan: 'Zastupujúca osoba ',
            },
            LossComponent: {
                enterLoss: "Zadajte stratu",
                useToPay: "Použiť na úhradu straty zisk z predchádzajúcich rokov?",
                feeToPay: "Použiť na úhradu straty príspevok spoločníkov?",
                year: "Rok",
                enterValue: "Zadajte hodnotu",
                value: "Hodnota",
                coOwnerPay: "Príspevok spoločníka",
            },
            ProfitComponent: {
                enterProfit: "Zadajte zisk",
                profit: "Zisk",
                enterReserve: "Zadajte príspevok do rezervného fondu",
                resrveFoundation: "Príspevok do rezervného fondu",
                enterSocialReserve: "Zadajte príspevok do sociálneho fondu",
                socialFoundation: "Príspevok do sociálneho fondu",
                enterBaseReserve: "Zadajte zisk určený na zvýšenie základného imania",
                baseFoundation: "Zisk určený na zvýšenie základného imania",
                enterProfitToSplit: "Zadajte zisk určený na rozdelenie medzi spoločníkov",
                profitToSplit: "Rozdelenie zisku medzi spoločníkov",
                enterName: "Zadajte názov",
                name: "Názov",
                enterValue: "Zadajte hodnotu",
                value: "Hodnota",
            },
            PropertyOwner: {
                titlesBefore: "Tituly pred menom vlastníka sú",
                titlesAfter: "Tituly za menom vlastníka sú",
                firstName: "Meno vlastníka je",
                lastName: "Priezvisko vlastníka je",
                enterTypeOfOwner: 'Je vlastník človek?',
                enterICO: 'IČO / identifikátor vlastníka je',
                enterICOPlaceholder: 'napíšte IČO alebo iný identifikačný udaj',
                enterBirthID: 'Rodné číslo / identifikátor vlastníka je',
                enterBirthIDPlaceholder: 'napíšte rodné číslo alebo iný identifikačný udaj',
                typeOfOwner: "Typ osoby",
                individual: "Človek",
                legalPerson: "Právnická osoba",
                enterOwner: 'Vlastníkom je',
                enterOwnerTooltip: 'Je potrebné správne napísať celé meno a priezvisko vlastníka, a prípadne aj všetky jeho tituly',
                enterOwnerName: 'Vlastníkom je',
                enterOwnerNameTooltip: 'Je potrebné správne napísať celé aktuálne obchodné meno vlastníka',
                titleName: 'Titul, meno a priezvisko',
                businessName: 'Obchodné meno',
                streetCity: 'ulica č., PSČ, mesto',
                enterOwnerLocation: 'Bydlisko vlastníka je',
                enterAdress: 'Sídlo vlastníka je',
                enterOwnerBirth: "Dátum narodenia vlastníka",
                dateOfBirth: 'Dátum narodenia',
                chooseIfOwner: "Má vlastník",
                ico: 'IČO',
                hasIco: 'Má vlastník IČO?',
                hasIcoTooltip: 'V niektorých krajinách neprideľujú právnickým osobám IČO, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.',
                IcoTooltip: "V niektorých krajinách neprideľujú právnickým osobám IČO, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.",
                BirthIDTooltip: "V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné ich sem vyplniť.",
                birthID: 'rodné číslo?',
                hasBirthID: 'Má vlastník rodné číslo',
                hasBirthIDTooltip: 'V niektorých krajinách neprideľujú osobám rodné číslo, ale osoby dostávajú iné identifikačné údaje. Je potrebné vybrať niektorú z možností.',
                orID: "alebo identifikačný údaj",
                id: 'Identifikačný údaj',
                enter: "Zadajte",
                owner: "vlastníka",
                birtIdOrId: 'Rodné číslo alebo identifikačný údaj',
                icoOrId: 'IČO alebo identifikačný údaj',
                enterRegistrationDisctrict: "Zadajte Okresný súd registrácie",
                registrationDistrict: "Okresný súd",
                enterPart: "Zadajte oddiel",
                part: "Oddiel",
                enterInsert: "Zadajte vložku",
                insert: "Vložka",
                addRepresentMan: "Pridať zastupujúcu osobu",
                representMan: 'V mene vlastníka bude podpisovať: ',
                enterFunc: "Z akej pozície?",
                func: "napr. konateľ",
                enterRepresentMan: "Napíšte jeho/jej titul, meno, priezvisko",
                tooltipPerson: "Je potrebné správne a dostatočne presne špecifikovať adresu bydliska vlastníka",
                tooltipCompany: "Je potrebné správne a dostatočne presne špecifikovať aktuálnu adresu sídla vlastníka"
            },
            PropertyType: {
                enterTypeOfProperty: 'Nehnuteľnosť ktorá je predmetom zmluvy je',
                enterTypeOfPropertyPlaceholder: 'vyberte druh nehnuteľnosti',
                enterTypeOfPropertyTooltip: 'Ak nie je bytom alebo nebytovým priestorom, tak ide o stavbu, ktorá má súpisné číslo.',
                typeOfProperty: "Druh nehnuteľnosti",
                building: "Stavba",
                flat: "Byt",
                noResidentPlace: "Nebytový priestor",
                flatNumber: 'Zadajte číslo bytu',
                noResidentNumber: 'Zadajte číslo nebytového priestoru',
                enterEntrance: "Zadajte vchod",
                entrance: "Vchod",
                enterFloor: "Zadajte poschodie",
                floor: "Poschodie",
                enterInventoryNumber: "Zadajte súpisné číslo",
                inventoryNumber: "Súpisné číslo",
                enterDeedNumber: "Zadajte číslo listu vlastníctva",
                deedNumber: "Číslo listu vlastníctva",
                enterSizeOfShare: "Zadajte veľkosť podielu na spoločných priestoroch",
                sizeOfShare: "Veľkosť podielu na spoločných priestoroch",
                enterDistrictOffice: "Zadajte okresný úrad",
                districtOffice: "Okresný úrad",
                enterCadastralTerritory: "Zadajte katastrálne územie",
                cadastralTerritory: "Katastrálne územie",
                enterMunicipality: "Zadajte obec",
                municipality: "Obec",
                enterDistrict: "Zadajte okres",
                district: "Okres",
                chooseParcelType: "Vyberte druh registra parcely",
                parcelRegister: "Parcela registra",
                enterParcelNumber: "Zadajte parcelné číslo",
                parcelNumber: "Parcelné číslo",
                enterTypeOfLand: 'Zadajte druh pozemku',
                enterTypeOfBuilding: 'Zadajte druh stavby',
                typeOfLand: 'Druh pozemku',
                typeOfBuilding: 'Druh stavby',
                addParcel: "Pridať parcelu",
            },
            NewOwnerComponent: {
                willOwnerHaveThisPart: 'Ponechá si spoločník túto časť?',
                part: "Časť",
                enterShareEur: "Zadajte podiel v €",
                shareInEur: "najmenej 750 €",
                enterSharePercents: "Zadajte podiel v %",
                shareInPercents: "Podiel v %",
                chooseTypeOfPerson: 'Je kupujúci človek?',
                typeOfPerson: "Typ osoby",
                searchORSR: "Vyhľadáme ho v databáze Obchodného registra SR?",
                searchWithNameOrICO: 'napíšte IČO alebo obchodné meno',
                enterName: 'Napíšte titul, meno, priezvisko kupujúceho',
                enterBusinessName: 'Napíšte obchodné meno kupujúceho',
                titleName: "napíšte celé meno",
                addTitlesBeforeName: "Zadajte tituly pred menom",
                titlesBeforeName: "Tituly pred menom",
                addName: "Zadajte meno",
                addYourSurname: "Zadajte priezvisko",
                surname: "Priezvisko",
                addTitlesAfterName: "Zadajte tituly za menom",
                titlesAfterName: "Tituly za menom",
                enterHomeLocation: 'Napíšte sídlo kupujúceho',
                enterAdress: 'Napíšte adresu kupujúceho',
                chooseDateOfBirth: "Dátum narodenia kupujúceho",
                dateOfBirth: 'napíšte dátum narodenia',
                chooseIfNewOwner: "Má kupujúci",
                ico: 'IČO',
                birthID: 'rodné číslo',
                orID: "alebo má iný identifikačný údaj?",
                dataID: "Identifikačný údaj",
                enter: "Zadajte",
                newOwner: "kupujúceho",
                orDataId: "alebo identifikačný údaj",
                specifySearchingName: 'Ak ste nenašli Váš subjekt, upresnite názov alebo zadajte IČO',
                noResult: 'Žiadny výsledok',
            },
            OwnerComponent: {
                guideOp: 'Kto predáva obchodný podiel?',
                chooseDateOfBirth: "Dátum narodenia predávajúceho",
                dateOfBirth: 'napíšte dátum narodenia',
                chooseConverterHave: "Má predávajúci",
                ico: 'IČO',
                birthID: 'rodné číslo',
                orID: "alebo má iný identifikačný údaj?",
                dataID: "Identifikačný údaj",
                enter: "Rodné číslo / ",
                converter: "predávajúceho je",
                enterPart: "Výška vkladu predávajúceho v € je",
                part: "napíšte sumu",
                enterSharePercents: "Obchodný podiel predávajúceho je v %",
                shareInPercents: "Podiel v %",
                enterPartsToCut: "Na koľko častí chcete podiel rozdeliť?",
                partsToCut: "Napíšte číslo",
            },
            ShareDivision: {
                capital: 'Základné imanie v €',
                addRepresent: "Pridať ďalšieho podpisujúceho?",
                representMan: 'V mene kupujúceho bude podpisovať:',
                enterFunc: 'Z akej pozície?',
                func: "napr. konateľ",
                enterName: 'Napíšte jeho/jej titul, meno, priezvisko',
                titleName: "titul, meno, priezvisko",
                representManSeller: 'V mene predávajúceho bude podpisovať:'
            },
            ShareDivisionSinglePerson: {
                capital: 'Základné imanie v €',
                addRepresent: "Pridať ďalšieho podpisujúceho?",
                representMan: 'V mene kupujúceho bude podpisovať:',
                enterFunc: 'Z akej pozície?',
                func: "napr. konateľ",
                enterName: 'Napíšte jeho/jej titul, meno, priezvisko',
                titleName: "titul, meno, priezvisko",
                representManSeller: 'V mene predávajúceho bude podpisovať:'
            },
            SecondNewOwnerComponent: {
                enterNewOwner: "Kto kupuje obchodný podiel?",
                chooseTypeOfPerson: 'Je to človek?',
                typeOfPerson: "Typ osoby",
                individual: "Človek",
                legalPerson: "Právnická osoba",
                searchORSR: "Vyhľadáme ho v databáze Obchodného registra SR?",
                searchZRSR: "Zadajte osobu z Živnostenského registra SR",
                searchWithNameOrICO: 'napíšte IČO alebo obchodné meno',
                enterName: 'Napíšte titul, meno, priezvisko kupujúceho',
                enterBusinessName: 'Napíšte obchodné meno kupujúceho',
                titleName: "napíšte celé meno",
                enterHomeLocation: 'Napíšte sídlo kupujúceho',
                enterAdress: 'Napíšte adresu kupujúceho',
                name: "Meno",
                chooseIfNewOwner: "Má kupujúci",
                enter: "Zadajte",
                newOwner: "kupujúceho",
                ico: 'IČO',
                birthID: 'rodné číslo',
                orID: "alebo má iný identifikačný údaj",
                dataID: "Identifikačný údaj",
            },
            SecondOwnerComponent: {
                chooseConverter: 'Kto predáva obchodný podiel?',
                converter: "napíšte titul, meno, priezvisko predávajúceho",
                chooseDateOfBirth: "Dátum narodenia predávajúceho",
                dateOfBirth: 'napíšte dátum narodenia',
                chooseConverterHave: "Má predávajúci",
                ico: 'IČO',
                birthId: 'rodné číslo',
                orId: "alebo má iný identifikačný údaj?",
                enter: "Napíšte",
                dataId: "identifikačný údaj",
                converter: "predávajúceho",
                enterPart: "Výška vkladu predávajúceho v € je",
                part: "napíšte sumu",
                enterPartInPercent: "Obchodný podiel predávajúceho je v %",
                partInPercent: "Podiel v %",
            },
            ShareTransfer: {
                capital: 'Základné imanie v €',
                addRepresentMan: "Pridať ďalšieho podpisujúceho?",
                representMan: 'V mene kupujúceho bude podpisovať:',
                addFunc: 'Z akej pozície?',
                func: "napr. konateľ",
                addTitleName: 'Napíšte jeho/jej titul, meno, priezvisko',
                titleName: "Titul, meno, priezvisko",
                representManSeller: 'V mene predávajúceho bude podpisovať:',
            },
            ShareTransferSinglePerson: {
                capital: 'Základné imanie v €',
                addRepresentMan: "Pridať ďalšieho podpisujúceho?",
                representMan: 'V mene kupujúceho bude podpisovať:',
                addFunc: 'Z akej pozície?',
                func: "napr. konateľ",
                addTitleName: 'Napíšte jeho/jej titul, meno, priezvisko',
                titleName: "Titul, meno, priezvisko",
                representManSeller: 'V mene predávajúceho bude podpisovať:',
            },
            TransferAquirerStatement: {
                chooseSignatureDate: "Vyberte dátum podpisu",
                dateOfSignature: 'napíšte dátum',
                addPlaceOfSignature: "Kde sa podpisovalo",
                placeOfSignature: "Napíšte miesto",
            },
            TransferSellerStatement: {
                chooseSignatureDate: "Vyberte dátum podpisu",
                dateOfSignature: 'Napíšte dátum',
                addPlaceOfSignature: "Kde sa podpisovalo",
                placeOfSignature: "Napíšte miesto",
            },
            DocumentsDownload: {
                enterOrderPassword: "Zadajte heslo objednávky",
                weAreCookingYourDocuments: "Usilovne pracujeme na vytvorení Vašich dokumentov.",
                itDoesntTakeMoreThan: "Nepotrvá to viac ako 5 minút.",
                allNews: "a vždy budete mať prehľad o svojich objednávkach aj špeciálnych ponukách.",
                itWorking: "Prebieha presmerovanie",
                payWall: "na platobnú bránu.",
                itsDone: "A je to hotové!",
                docsAreReady: "Vaše dokumenty sú pripravené,",
                justDownload: "stačí ich len stiahnuť.",
                linkInEmail: "V e-maili Vás už čaká správa, kde nájdete link a heslo, vďaka čomu máte prístup k svojim dokumentom vždy, keď ich potrebujete.",
                thanks: "Ďakujeme, že ste s nami.",
                downloadAll: "Stiahnuť všetky dokumenty",
                operator: "Portál prevádzkuje",
                vop: "Všeobecné obchodné podmienky",
                gdpr: "Ochrana osobných údajov",
                sthWntWrong: "Niečo sa pokazilo",
                sthWntWrong2: "Pri generovaní dokumentov nastala neočakávaná chyba"
            },
            MyDocumentsListPage: {
                uploadFile: "Nahrajte súbor."
            },
            MyDocumentListBox: {
                fileName: "Názov súboru",
                s3FileName: "S3 Názov súboru",
                created_at: "Vytvorené",
                updated_at: "Upravené"
            },
        },
        screens: {
            DitecModalBox: {
                loadingWait: "Súbory sa nahrávajú, prosím čakajte",
                didntRecognise: "Nebolo rozoznané rozšírenie D.Bridge 2, nainštalujte ho kliknutím na tlačidlo a znovu načítajte stránku.",
                didntInstalledWell: "Nebolo rozoznaná aplikácia D.Launcher 2, nainštalujte ju kliknutím na tlačidlo. Po inštalácií reštartujte počítač.",
                restartPage: "Vyskytla sa neznáma chyba, obnovte stránku a skúste to znova",
                signInProgress: "Prebieha podpisovanie",
                errorInSign: "Vyskytla sa chyba",
                continueInApp: "Pokračujte v aplikácií dSigner",

            },
            UserSignatureRequestListBox: {
                close: "Zatvoriť",
                open: "Detail žiadosti",
                didntFill: 'Nevyplnené',
                sign: "Podpísať KEP-om",
                step: "Tu niečo nesedí, preverte si to",
                signingTitle: "Podpísanie"
            },
            InviteModalBox: {
                enterAdresses: "Zadajte emailovú adresu osoby, ktorá má dokument podpísať",
                enterValidMail: 'Prosím zadajte platný email.',
                sendRequest: "Odoslať žiadosť o podpis",
                sendEmail: "Pridať email",
            },
            UserOrderList: {
                requestWasSent: "Žiadosť o podpis bol poslaný na emailovu adresu: ",
                requestFrom: "Žiadosť o podpis od: ",
                cancelRequestTooltip: "Zrušiť žiadosť o podpis",
                chooseDocument: "Požiadať o podpis inú osobu",
                download: "Stiahnuť",
                whoSign: "Dokument má podpísať:",
                otherDocuments: "Ostatná dokumentácia:",
                sign: "Podpísať elektronicky KEP-om",
                createSign: "Podpísať prstom",
                deleteSign: "Vymazať podpis prstom",
                signsRequestedFrom: "Podpisy vyžiadané od:",
                signedBy: "Dokument podpísal KEP-om:",
                signedByFinger: "Dokument podpísal prstom:",
                sendFeedback: "Odoslať hodnotenie",
                yourFeedback: "Vaše hodnotenie:",
                signingTitle: "Podpísanie"
            },
            ValidatorModal: {
                title: "Našli sme miesta kde niečo nesedí, chcete napriek tomu pokračovať?",
                step: "Tu niečo nesedí"
            }
        }
    },
    en: {
        artifacts: {
            SignatureCanvasArtifact: {
                createSignature: "Create a signature",
                create: "Create",
                loadFile: "or upload a file",
                signature: "Signature",
                missingSignatures: 'The finger signatures of the following persons are missing, it will no longer be possible to add them after signing by KEP.',
                save: "Apply",
                clear: "Change",
                close: 'Close',
                orderDetail: 'Order detail'
            },
            DocumentOverview: {
                documentOverview: 'Document preview',
                cancel: 'Close',
                preview: 'Preview'
            },
            AdressAutocompleteInputsBox: {
                adress: "street and number, postal code, city",
            },
            AddressAutoCompleteSeperatedInputBox: {
                street: "Street",
                streetSmall: "- street",
                streetSmallSecond: "Street",
                adressNumber: "Number",
                city: "City",
                poscode: "Postal code",
                chooseCountry: "Choose country",
                country: "Country",
            },
            BaseInvestmentBox: {
                baseFinance: "Base investment"
            },
            BusinessTransferBox: {
                companyPart: "part of the company",
                fullCompany: "whole company",
                enterPartCompanyName: "Enter the name of the company part",
                partCompanyName: "Name of the company part",
            },
            CompanyAvailabilityInputBox: {
                forSure: "The chosen trade name is currently not used by any other company. To increase your legal certainty, we have checked it on",
                orsrsk: "orsr.sk",
                unavailable: "The chosen trade name is already in use. Please choose another one."
            },
            ContractModalBox: {
                "title": "Service Agreement",
                "parties": "Contracting Parties",
                "lawyersOffice": "Law Firm Matejka Friedmannová Ltd.",
                "withCompanyAdress": ", with registered office at Dunajská Street 48, 811 08 Bratislava, ID: 47 248 998, VAT ID: SK 2023808765, a business entity registered in the Commercial Register maintained by the District Court Bratislava III, Section Ltd, Insert No. 90113/B, represented by JUDr. Ondrej Matejka, authorized representative acting independently (hereinafter referred to as \"",
                "and": "and",
                "lawyer": "Lawyer",
                "orAnd": "\" and/or \"",
                "operator": "Operator",
                "withAdress": ", with registered office at ",
                "companyWrittenIn": ", a business entity registered in the Commercial Register maintained by ",
                "part": ", Section: ",
                "insert": ", Insert No.: ",
                "order": ", on behalf of whom the person completing the order is authorized to act independently and without any restrictions (hereinafter referred to as \"",
                "client": "Client",
                "user": "User",
                "canActAlone": ", on behalf of whom the person completing the order is authorized to act independently and without any restrictions (hereinafter referred to as \"",
                "articleOne": "Article I",
                "baseAgreement": "Basic Agreement",
                "firstRule": "The Lawyer undertakes to provide the Client with Application Services under the conditions agreed upon in this Service Agreement and under the conditions stipulated in the Terms of Service.",
                "definatedDown": "term defined below in the text",
                "secondRule": "The Client undertakes to specify to the Lawyer the need for legal assistance exclusively by entering User's requirements into the Application, and valid entry of User's requirements for the provision of Application Services is considered exclusively as the completion of the order.",
                "thirdRule": "The Lawyer begins to provide the Client with Application Services immediately following the completion of the order.",
                "fourthRule": "The Lawyer is responsible for the Legal Part of the Documents created during the term of this Service Agreement.",
                "fifthRule": "The Client undertakes to familiarize himself/herself in detail with all available instructions provided by the Lawyer, with the Terms of Service",
                "fifthRuleTwo": ", with cookie handling principles, and with personal data processing principles. ",
                "sixsthRule": "The Lawyer delivers the provided Application Services to the Client after the comprehensive completion of processing the entire Client's request.",
                "seventhRule": "The Lawyer delivers the provided Application Services to the Client exclusively by delivering the Generated Documents to the User.",
                "eightRule": "The Lawyer delivers the Generated Documents to the User after the payment of the Price, usually within five minutes after the payment of the Price; non-compliance with this deadline may be caused, in particular, by the instability of the User's internet connection and/or any other technical deficiencies of the User's internet connection and/or any technical deficiencies of the User's Device and/or the Application.",
                "ninethRule": "The Client is entitled to make a complaint to the Lawyer regarding the provided Application Services in accordance with the relevant provisions of the Commercial Code.",
                "articleTwo": "Article II",
                "lawyersPrize": "Lawyer's Remuneration and Payment Terms",
                "tenthRule": "The Client undertakes to pay the Price to the Lawyer for the provision of Application Services.",
                "eleventhRule": "The Price is agreed upon as a lump sum remuneration and is governed by Decree No. 655/2004 Coll. on Lawyers' Fees and Reimbursements for Legal Services and by this Agreement on the Provision of Services.",
                "twelveRule": "The Lawyer invoices the Price for the provided Application Services only upon the complete completion of the Client's entire request processing.",
                "thirtteenthRule": "The conditions for issuing, sending, and delivering invoices are included in the GTC.",
                "articleThree": "Article III",
                "termsAndConditions": "Contractual Relationship of the Agreement on the Provision of Services and the General Terms and Conditions",
                "fourteenthRule": "The Lawyer has established General Terms and Conditions for the provision of legal services using the Application, and the Lawyer has published them on the Internet address before the conclusion of this Agreement on the Provision of Services, in the wording in which the GTC are effective on the day of the conclusion of this Agreement on the Provision of Services (hereinafter referred to as the \"",
                "GTC": "GTC",
                "fifteenthRule": "The GTC are an integral part of this Agreement on the Provision of Services.",
                "sixteenthRule": "In the event of a conflict/inconsistency/discrepancy between the text of this Agreement on the Provision of Services and the text of the GTC, the agreements contained in this Agreement on the Provision of Services shall take precedence.",
                "articleFour": "Article IV",
                "commonProvisions": "Common provisions",
                "seventeenthRule": "This Agreement on the Provision of Services is concluded electronically by using the Application between the contracting parties.",
                "eighteenthRule": "By Completing the order, this Agreement on the Provision of Services is concluded between the Operator and the User.",
                "nineteenthRule": "This Agreement on the Provision of Services becomes effective upon its conclusion.",
                "twentiethRule": "Unless otherwise specified, this Agreement on the Provision of Services takes effect upon its conclusion.",
                "twentyFirstRule": "The Operator's Obligation to Deliver Generated Documents to the User occurs only upon payment of the Price. The User acknowledges and expressly agrees that the Operator is not obliged to Deliver Generated Documents to the User before the User pays the Price to the Operator.",
                "twentySecondRule": "This Agreement on the Provision of Services is concluded for an indefinite period.",
                "twentyThirdRule": "This Agreement on the Provision of Services is valid and binding also for the legal successors of the contracting parties.",
                "twentyFourthRule": "The Lawyer, when providing legal aid and legal services, complies with valid legal regulations governing the practice of advocacy and with binding regulations and guidelines of the Slovak Bar Association.",
                "twentyFifthRule": "The Client grants the Lawyer permission to use publicly available information about the Client for the purpose of presenting the Lawyer, especially granting the Lawyer permission to use the trade name and trademark of the Client for reference purposes of the Lawyer.",
                "articleFive": "Article V",
                "finalProvisions": "Final provisions",
                "twentySixRule": "The contracting parties consider the content of this Agreement on the Provision of Services to be confidential and undertake to protect it. The contracting parties have agreed that neither of them will independently inform third parties about the content of this Agreement on the Provision of Services, nor about the rights and obligations arising from it for the contracting parties, without the prior consent of the other party; this does not apply to cases of information and notification obligations arising from specific legal regulations for the contracting parties.",
                "twentySevenRule": "By signing this Agreement on the Provision of Services, the Client confirms that all conditions and prerequisites set by their internal regulations and mandatory legal regulations have been fulfilled for the conclusion of this Agreement on the Provision of Services on behalf of the Client, and that this Agreement on the Provision of Services is concluded by a person authorized without restrictions and reservations under applicable legal regulations on behalf of the Client.",
                "twentyEightRule": "The contracting parties declare that they will refrain from any actions that would hinder or impede the fulfillment of the subject matter of this Agreement on the Provision of Services.",
                "twentyNineRule": "The Client declares that they have carefully read this Agreement on the Provision of Services, understood its content well, that this Agreement on the Provision of Services is an expression of their free, serious, and definite will, that they enter into this Agreement on the Provision of Services freely and not under duress or disadvantageous conditions, as a sign of which the Client proceeded to conclude this Agreement on the Provision of Services.",
                "thirtyRule": "This contract is prepared electronically."
            },
            "EstablishmentPeriodBox": {
                "companyIsMake": "The company is established for a period",
                "forever": "Indefinitely",
                "onDate": "Until the date",
                "chooseDate": "Choose date"
            },
            "GuidanceModalBox": {
                "lawyersInfo": "Lawyer's advice and recommendations",
                "complexInfo": "We have summarized important information for you. Thank you and let's continue",
                "readInfo": "I have read the lawyer's advice",
                "lawyerAdvice": "Lawyer's advice and recommendations"
            },
            "NewCompanyAddressBox": {
                "companyAdress": "The company's address will be",
                "cityAdress": "Street, House Number, Postal Code, City",
                "tooltip": "It is necessary to correctly write the complete address where the new registered office of the company will be, to avoid problems with the delivery of documents"
            },
            "NewCompanyNameBox": {
                "companyName": "Company name"
            },
            "numberOfPropertyOwners": {
                "numberOfPropertyOwnersText": "How many individuals own the property where the registered office will be located?",
                "numberOfOwnersTooltip": "If you do not wish to generate a consent of the property owner, leave it blank or choose 0"
            },
            "RecognizeAbilityBox": {
                "recognizeAbilityText": "According to the Commercial Code, for the convening of a general meeting and making decisions on individual agenda items, shareholders who hold at least 50% of all votes must be present. However, the articles of association may specify a higher or lower number of required votes. How is it in this company? How many % of votes of all shareholders are required?",
                "noLimits": "This company has no special conditions for convening a general meeting and voting other than those specified by the Commercial Code."
            },
            "RepresentationBox": {
                "representation": "We will handle it for you",
                "wantRepresentation": "Do you want us to handle it for you at the Commercial Register of the Slovak Republic?",
                "freeService": "If you choose this service NOW, it is free of charge",
                "moreInfo": "More information can be found in the Price List.",
                "yes": "Yes",
                "no": "No",
                "thankYou": "Thank you, we will be happy to represent you.",
                "orsr": "at the Commercial Register?"
            },
            "SelectBoardBox": {
                "nameTitleSurname": "Title, First Name, Last Name"
            },
            "KonatelBox": {
                "otherAdress": "Other address",
                "otherPerson": "Other person",
                "enterTitle": "Enter titles before the name",
                "enterTitleAfter": "Enter titles after the name",
                "titleAfter": "Titles after the name",
                "enterName": "Enter the first name",
                "name": "First Name",
                "enterSurname": "Enter the last name",
                "surname": "Last Name",
                "beforeName": "Titles before the name",
                "selectAdress": "Enter the address",
                "enterName": "The name of the executive is",
                "nameTitleSurname": "Title, First Name, Last Name"
            },
            "LikvidatorBox": {
                "otherPerson": "Other person",
                "otherAdress": "Other address",
                "selectAdress": "Enter the address",
                "enterName": "The name of the liquidator is",
                "nameTitleSurname": "Title, First Name, Last Name",
                "enterTitlesBeforeName": "Enter titles before the name",
                "titlesBefore": "Titles before the name",
                "enterTitlesAfter": "Enter titles after the name",
                "titlesAfter": "Titles after the name",
                "enterName": "Enter the first name",
                "enterSurname": "Enter the last name",
                "surname": "Last Name",
                "name": "First Name"
            },
            "SelectPaymentBox": {
                "choose": "- Select -",
                "cash": "In cash",
                "transfer": "By bank transfer",
                "didRecieve": "Did the recipient receive the agreed payment?"
            },
            "ProkuristaBox": {
                "otherAdress": "Other address",
                "otherPerson": "Other person",
                "enterTitles": "Enter titles before the name",
                "titlesBefore": "Titles before the name",
                "enterTitlesAfter": "Enter titles after the name",
                "titlesAfter": "Titles after the name",
                "enterName": "Enter the first name",
                "name": "First Name",
                "enterSurname": "Enter the last name",
                "surname": "Last Name",
                "selectAdress": "Enter the address",
                "nameTitleSurname": "Title, First Name, Last Name"
            },
            "SpolocnikBox": {
                "otherPerson": "Other person",
                "otherAdress": "Other address",
                "selectAdress": "Enter the address",
                "nameTitleSurname": "Title, First Name, Last Name",
                "enterName": "Enter the first name"
            },
            "TitleNameSurnameArtifact": {
                "titlesBeforeName": "Titles before the name",
                "titlesAfterName": "Titles after the name",
                "name": "First Name",
                "surname": "Last Name"
            },
            RegistrationCertificateArtifact: {
                druh: "Druh",
                znacka: "Znacka",
                typ: "Typ",
                farba: "Farba",
            },
            VOPmodalBox: {
                "vopIntro": "Advokátska kancelária Matejka Friedmannová s. r. o., with its registered office at: Dunajská 48, 811 08 Bratislava - m. č. Staré Mesto, Slovak Republic, Company ID: 47 248 998, registered in the Commercial Register kept by the District Court Bratislava III, Section Sro, Insert No. 90113/B, has established the following General Terms and Conditions (hereinafter referred to as the '",
                "vop": "GTC",
                "articleOne": "Article I",
                "mainDefinitions": "Basic terms and definitions",
                "aplication": "Application",
                "b2bApp": "means the B2B [business-to-business] software application called MOJEZMLUVY.SK developed by the Operator and used by the Operator ",
                "contract": "for the conclusion of the Service Provision Agreement with the User, ",
                "using": "for the provision of Application Services and",
                "payPrice": "for ensuring the payment of the Price for the provision of Application Services; part of the Application is a website accessible from the Internet address;",
                "copyrightLaw": "Copyright Law",
                "means": "means Act No. 185/2015 Coll. on Copyright and Related Rights, as amended;",
                "price": "Price",
                "definition": "means the amount electronically agreed upon according to the Price List of Services between the Operator and the User for the provision of individual Application Services to the User, which the User undertakes to pay to the Operator using the secure payment gateway of the Application. The Price is stated mainly in the section of the Application called Cart, and the amount of the Price depends on the scope of the User's order of Application Services. The Price does not include any hidden fees. The Price is final and is divided into an amount of the base of value added tax and an amount of value added tax. The Price also includes a reimbursement of the Operator's actual administrative expenses;",
                "priceList": "Price List of Services",
                "priceDefinition": "means the price list designated by the Operator for the provision of Application Services and valid on the date of provision of Application Services to the User. The Price List of Services includes, in particular, the amounts of prices and fees and is published at the Internet address;",
                "civilOrder": "Civil Out-of-Court Order",
                "lawDefinition": "means Act No. 161/2015 Coll. on Civil Out-of-Court Order, as amended;",
                "completeOrder": "Completion of Order",
                "itMeans": "means filling in all mandatory fields of the order form of the Application by the User and confirming the order by the User by actively clicking on the respective button in the Application ",
                "finishOrder": " with the inscription 'Complete order with the obligation to pay' or ",
                "button": "on the respective button in the Application with a different inscription of the same content meaning;",
                "document": "Document",
                "partsOfDocument": "means a coherent and interconnected part of the Application, displaying a text field to the User with content related to the scope of the User's order of Application Services; the Document is divided into",
                "firstPartDocument": "Legal part of the Document and ",
                "infoByUser": "Data filled in by the User. The Document is displayed to the User in the Application primarily for the purpose of providing the User with an online overview of the consistency and grammatical coherence of the Data filled in by the User with the Legal part of the Document. By displaying the Document, the Application allows the User to perform online checks for errors/deficiencies/inaccuracies in the Data filled in by the User and enables the User to make corrections/supplements to the Data filled in by the User in the user interface of the Application;",
                "deliverDocuments": "Delivery of Generated Documents",
                "means": "means",
                "downloadDocuments": "providing the option to download Generated Documents in the Application to the User's Device and/or",
                "hyperLink": "sending a hyperlink for downloading Generated Documents to the email address provided by the User in the Application's order form and sending a password to open the sent hyperlink to the mobile phone number provided by the User in the Application's order form. Valid Delivery of Generated Documents to the User also occurs if",
                "downloadFromApp": "the User does not use the option to download Generated Documents from the Application to the User's Device and/or",
                "badUserInfo": "the User provides a non-existing/non-functioning/incorrect/invalid email address and/or non-existing/non-functioning/incorrect/invalid mobile phone number in the Application's order form;",
                "internetAdress": "Internet address",
                "anyAdress": "means any internet address from which the Application is accessible, especially the website https://www.mojezmluvy.sk/;",
                "itAdmin": "IT admin",
                "itAdminMeans": "means the designation for each natural person expressly authorized by the Operator to access the admin interface of the Application;",
                "gdpr": "GDPR Regulation",
                "gdprMeans": "means Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data and on the free movement of such data, and repealing Directive 95/46/EC (General Data Protection Regulation);",
                "register": "Business Register of the Slovak Republic",
                "registerMeans": "means the public register in which data prescribed by law concerning entrepreneurs or other persons specified by a special law are entered;",
                "commercialCode": "Commercial Code",
                "commercialMeans": "means Act No. 513/1991 Coll. the Commercial Code, as amended;",
                "civilCode": "Civil Code",
                "civilMeans": "means Act No. 40/1964 Coll. the Civil Code, as amended;",
                "personInfo": "Personal Data",
                "personMeans": "means data concerning an identified or identifiable natural person, who can be identified directly or indirectly, in particular by reference to an identifier such as a name, surname, identification number, location data, or online identifier, or by one or more factors specific to the physical, physiological, genetic, mental, economic, cultural, or social identity of that natural person.",
                "user": "User",
                "userMeans": "means a business company registered in the Business Register of the Slovak Republic; or a business company to be established by the Application's Service; which uses the Application for the purpose of purchasing Application Services. The User is not a natural person. The User is not a consumer. The User is obliged, at his own responsibility, to ensure that persons authorized to do so under the provisions of Section 20 of the Civil Code use the Application on his behalf;",
                "lawDocument": "“Legal Part of the Document”",
                "lawDocumentMeans": "means the text field of the Document created by the Operator and containing the complete text and/or a part of the text, including minutes from the general meeting, contracts, agreements, statements, or any other legally relevant Document for proceedings in the Commercial Register according to the Civil Non-Contentious Rules;",
                "operator": "“Operator”",
                "operatorMeans": "means a commercial company, the law firm Matejka Friedmannová s.r.o., with its registered office at Dunajská 48, 811 08 Bratislava – m. č. Staré Mesto, Slovak Republic, Identification Number: 47 248 998, email: orsr.help@matejka.company, registered in the Commercial Register kept by the District Court Bratislava III, Section: Sro, Insert No.: 90113/B, which is the owner and administrator of the Application. The Operator, in accordance with the GDPR and the Personal Data Protection Act, has defined the purpose and means of processing Personal Data and processes Personal Data on its own behalf;",
                "appServices": "“Application Services”",
                "appServicesMeans": "means the collective designation for the one-time provision of legal services to the User, which the Operator provides to the User in accordance with the Advocacy Act, under the conditions agreed upon in the Service Agreement, and exclusively by using the Application, and the content of which [legal service] is ",
                "appServicesMeansOne": "preparation of documents for changing the User's registered data in the Commercial Register of the Slovak Republic, based on the User's requests entered in the Application by completing the order, and/or preparation of documents for the establishment of the User, based on the User's requests entered in the Application by completing the order, and",
                "appServicesMeansTwo": "drafting of Documents, and",
                "documentGeneration": "Document Generation, and",
                "deliverGeneratedDocuments": "Delivery of Generated Documents to the User;",
                "consumer": "“Consumer”",
                "consumerMeans": "means a natural person who, when using the Application, does not act within the scope of their business or other entrepreneurial activity.",
                "dataByUser": "“Data Filled in by the User”",
                "dataByUserMeans": "means the text field of the Document created by the User in the user interface of the Application;",
                "generatedDocument": "“Generated Document”",
                "generatedDocumentsMeans": "means an uneditable file in the format of “pdf,” “docx,” “odt,” “rtf,” or any other commonly used format with the text content identical to the content of the Document at the time of completing the order;",
                "advocacyLaw": "“Advocacy Act”",
                "advocacyLawMeans": "means Act No. 586/2003 Coll. on Advocacy and amending Act No. 455/1991 Coll. on Trade Licensing (Trade Licensing Act), as amended;",
                "eGoverment": "“e-Government Act”",
                "eGovermentMeans": "means Act No. 305/2013 Coll. on the Electronic Performance of Powers of Public Authorities and amending certain laws (e-Government Act), as amended;",
                "userDataLaw": "“Personal Data Protection Act”",
                "userDataLawMeans": "means Act No. 18/2018 Coll. on Personal Data Protection and amending certain laws;",
                "userDevice": "\"User Device\"",
                "userDeviceMeans": "means any device, especially desktop PC, laptop, notebook, smartphone, and other devices used by the User to access the Application;",
                "userRepresentation": "\"User Representation\"",
                "userRepresentationOne": "means the legal representation of the User according to the relevant provisions of the Civil Non-Contentious Procedure Code, the Law on Advocacy, and other relevant legally binding regulations in the Slovak Republic, based on a special written power of attorney granted to the Operator,",
                "userRepresentationTwo": "in the proceedings for the registration of changes in the data registered about the User in the Commercial Register of the Slovak Republic, exclusively to the extent of the Application Services provided to the User by Delivery of Generated Documents and/or",
                "userRepresentationThree": "in the proceedings for the initial registration of the User in the Commercial Register of the Slovak Republic, exclusively to the extent of the Application Services provided to the User by Delivery of Generated Documents. The Operator is obliged to carry out the User Representation only if all of the following cumulative conditions are met:",
                "printDocuments": "The User printed all the Generated Documents without making any modifications to their content and ensured that the signatures of the acting persons are as indicated in the Generated Documents,",
                "allDocuments": "The User delivered all the documents according to point 26.1. of these Terms and Conditions to the Operator within 25 days from the Delivery of Generated Documents, namely",
                "allDocumentsOne": "in the form of an original copy of each Generated Document in paper form, delivered to the Operator's registered office address, or",
                "allDocumentsTwo": "in the form of an electronic document signed with a qualified electronic signature [QES] and delivered to the Operator's electronic mailbox established on the Central Public Administration Portal at www.slovensko.sk, in accordance with the Act on e-Government.",
                "finishOrderLaw": "By completing the order, the User gives the Operator an explicit, irrevocable, unconditional, unchangeable, temporally or otherwise unlimited instruction not to carry out any verification of the accuracy/completeness/truthfulness of the Data filled in by the User or any verification of the completeness of documents required by legal regulations for User Representation.",
                "userPresentation": "The Operator will carry out the User Representation",
                "recordChanges": "in proceedings for the registration of changes in the data registered about the User in the Commercial Register of the Slovak Republic by submitting an electronic proposal to the relevant registration court or",
                "recordChangesOne": "in proceedings for the notification of trade authorizations and registration of changes in the data registered about the User in the Commercial Register of the Slovak Republic, based on the provisions of Directive 2006/123/EC on services in the internal market, by submitting an electronic proposal to the electronic single contact point in the Slovak Republic or",
                "recordChangesTwo": "in proceedings for the notification of trade authorizations and initial registration of the User in the Commercial Register of the Slovak Republic, based on the provisions of Directive 2006/123/EC on services in the internal market, by submitting an electronic proposal to the electronic single contact point in the Slovak Republic, and",
                "recordChangesThree": "by delivering a decision issued in the proceedings according to the preceding points (a), (b), or (c) of this sentence to the email address provided by the User in the application order form;",
                "changesContract": "\"Service Agreement\"",
                "changesContractMeans": "means a written agreement electronically concluded in the Application between the User and the Operator, based on which the Operator undertakes to provide the User with the Services of the Application, and the User undertakes to pay the Operator the Price. The service provision agreement regulates the rights and obligations of the Operator and the User regarding the provision of the Services of the Application;",
                "articleNumberTwo": "Article II.",
                "rulesOfApp": "Rules and conditions of using the Application",
                "thisVopEdits": "These T&C govern ",
                "rulesOfUse": "the conditions and rules of using the Application and ",
                "lawBetween": "the mutual rights and obligations between the Operator and the User based on the service provision agreement.",
                "appNotFor": "The Application is not intended for Consumers. Consumers are prohibited from using the Application.",
                "flawless": "The Operator does not guarantee uninterrupted functionality of the Application or flawless operation of the Application to anyone.",
                "operatorIsNot": "The Operator is not obliged to provide the Services of the Application immediately, continuously, or without interruptions.",
                "everybodyUse": "Anyone who uses the Application has obligations as a User arising from these T&C and legally binding regulations in the Slovak Republic.",
                "everybodyHaveTo": "Everyone is obliged to comply with the obligations of a User arising from these T&C and legally binding regulations in the Slovak Republic when using the Application.",
                "everybodyCould": "Everyone is entitled to use the Application exclusively in the user interface of the Application.",
                "onlyAdmin": "The Operator ensures the administrative interface of the Application against accidental entry/penetration by third parties; only the IT admin has access to the administrative interface of the Application.",
                "nobodyBesidesAdmin": "Everyone is prohibited from accessing the administrative interface of the Application.",
                "appPurpose": "The purpose of the Application is solely to conclude the Service Provision Agreement, provide the Services of the Application, and ensure payment of the Price for the provision of the Services of the Application.",
                "appOnlyForSale": "The User is obliged to use the Application solely for the purpose of purchasing the Services of the Application and paying the Price for the provision of the Services of the Application.",
                "userUsingApp": "The User and the person acting on behalf of the User when using the Application are jointly and severally liable to the Operator for any damage caused by the breach of obligations of the User arising from these T&C.",
                "userAccept": "By using the Application, the User accepts these T&C, undertakes to abide by them, and undertakes to correctly fulfill all obligations arising from these T&C as a User.",
                "usingAppToBuy": "The use of the Application, the purchase of the Services of the Application, and the payment of the Price for the provision of the Services of the Application are conditioned by internet access. Internet access is not part of the Application or the Services of the Application.",
                "operatorCan": "The Operator is not responsible for any restrictions on the use of the Application, any defects of the Services of the Application, and any defects in the payment of the Price for the provision of the Services of the Application caused by the instability of the User's internet connection and/or any other technical insufficiency of the User's internet connection and/or any technical insufficiency of the User's Device and/or the Application.",
                operatorDont: "The Operator is not responsible for any damages incurred by the User in connection with the use of the Application or the provision of Application Services, or in connection with the payment of the Price for the provision of Application Services, which were caused to the User by the instability of the User's internet connection and/or any other technical inadequacy of the User's internet connection and/or any technical inadequacy of the User's Device and/or the Application.",
                operatorAndRisk: "The Operator shall not be liable to anyone for any direct, incidental, consequential, special, punitive and/or similar damages, including [but not limited to] liability for loss of income, loss of profit, loss of data or operational disruptions (service interruptions) or for other intangible losses (even if such losses are qualified) arising out of and/or in connection with ",
                withThisVOP: "these T&C and/or",
                appService: "the Application Services and/or",
                appForContract: "the Application, whether based on a Service Agreement, intentional infringement of rights or any other legal basis, regardless of whether the Operator has notified the User [or whether the User has been notified] of the possibility of such damages.",
                appPrice: "By using the Application, the User implicitly assures the Operator that the User incurs no costs associated with the use of the Application, especially no specific costs for the use of remote communication means.",
                userRespects: "The User is obliged to respect the rights and legitimate interests of the Operator when using the Application, especially when dealing with copyrighted works and other intellectual property.",
                userCant: "The User is prohibited from using the Application in a manner that violates the Application and/or restricts the operation of the Application and/or limits the functionality of the Application.",
                userCantOne: "The User is prohibited from interfering with the Application or its parts in any way, altering, copying and/or extending the appearance, graphical elements, interface, technical nature and other characteristics of the Application.",
                userCantTwo: "The User is prohibited from providing access to the Application to third parties.",
                userCantThree: "The User is prohibited from providing services to third parties through the Application.",
                userHaveTo: "The User is obliged to ensure that in case of misuse or suspicion of misuse of the Application, all necessary actions are taken to discontinue such a state or activities that violate legal regulations or contractual agreements between the User and the Operator, and also promptly eliminate all consequences of such activities and interventions in the legitimate interests of the Operator; this does not affect the User's liability for damages caused to the Operator.",
                userCould: "The User is entitled to order the Application Services from the Operator by concluding a Service Agreement.",
                isForbidden: "The User is prohibited from:",
                useProfanity: "using vulgarisms, phrases and/or verbal or written expressions whose direct or indirect meaning contradicts generally accepted social morals and good manners,",
                useReservations: "making threats and personal attacks against the Operator, other Users or any third parties,",
                useLies: "providing untrue, unverified, misleading, offensive or deceitful information about another person,",
                "useViolence": "promote violence and openly or covertly incite hatred based on gender, race, skin color, language, religion and belief, political or other beliefs, national or social origin, nationality or ethnic group, or for any other reason,",
                "useWar": "promote war or describe cruel or inhumane actions in a manner that trivializes, justifies, or approves of them,",
                "useAlcohol": "openly or covertly promote alcohol, alcoholism, smoking, drug use, poisons and precursors, or downplay the consequences of using such substances,",
                "useFear": "endanger the physical, mental, or moral development of minors or disrupt their mental health and emotional well-being,",
                "useChildPornography": "promote child pornography,",
                "useBadTexts": "publish nonsensical or unintelligible texts, as well as engage in other activities that could potentially lead to the restriction or reduction of the quality of the Application and/or the quality of the provided Application Services,",
                "usePrivateInfo": "disclose personal data about other individuals, particularly their name, surname, address, or telephone number, unless the person concerned has given their consent,",
                "shareReservations": "spread obscene, vulgar, and offensive materials and illegal materials, including posting a link to any websites with such content,",
                "takeUserInfo": "obtain the login names and/or passwords of other Users,",
                "editApp": "abuse, block, modify, or otherwise alter any part of the Application, or attempt to disrupt the stability, integrity, operation, or data of the Application,",
                "hackApp": "use mechanisms, software, or other procedures that could have a negative impact on the operation of the Application,",
                "shareCompetition": "disclose any information that may constitute unfair competition as defined in Sections 44-51 of Act No. 513/1991 Coll., Commercial Code, as amended,",
                "shareCommercial": "publish any advertising or promotion of products, goods, or services.",
                "articleThree": "Article III",
                "contractOfProvision": "Contract for Provision of Services",
                "finishOrderMoment": "By completing the order, a moment arises when the Contract for Provision of Services is concluded between the Operator and the User.",
                "acceptVOP": "The User declares that they have thoroughly and in detail familiarized themselves with the wording of the Contract for Provision of Services and these Terms and Conditions before concluding the Contract for Provision of Services.",
                "userAcceptContract": "By concluding the Contract for Provision of Services, the User implicitly confirms that the provisions of the Contract for Provision of Services and the provisions of the Terms and Conditions are understandable and clear to them.",
                "partOfContractIsVOP": "These Terms and Conditions are an integral part of the Contract for Provision of Services.",
                "contractIsActive": "The Contract for Provision of Services is valid and binding for the successors of the Operator and the successors of the User.",
                "userAcceptActiveContract": "By concluding the Contract for Provision of Services, the User implicitly confirms that the Operator is not obliged to verify or in any way check the data provided by the User in the Application order form, in particular, the Operator is not obliged to verify whether the email address or mobile phone number provided by the person acting on behalf of the User is nonexistent/non-functioning/incorrect/invalid.",
                "userCloseContract": "The User, by concluding the Contract for Provision of Services, implicitly confirms that the Operator is not obliged to verify or in any way check the data provided by the User.",
                "operatorAccept": "The Operator does not guarantee to anyone that the data provided by the User can be registered in the Commercial Register of the Slovak Republic.",
                "operatorInform": "The Operator notifies the User, and the User acknowledges, that by concluding the Contract for Provision of Services, the User obliges the Operator to immediately commence the provision of Application Services.",
                "userAcceptService": "By concluding the Contract for Provision of Services, the User implicitly confirms that the Operator has properly and sufficiently informed them, through the Application, about the expected scope of legal actions necessary to provide the Application Services in the extent of the User's order.",
                "operatorAutomaticaly": "By concluding the Contract for Provision of Services, the User implicitly confirms that the Operator automatically begins providing the Application Services to the User at the moment of concluding the Contract for Provision of Services, even before the payment of the Price.",
                "operatorOnline": "By concluding the Contract for Provision of Services, the User implicitly confirms that the User has used the opportunity to identify errors/deficiencies/incorrectness of the data provided by the User online,",
                "controllData": "primarily by verifying the accuracy and completeness of the data provided by the User in the Application, and",
                "controllText": "by checking the Document text in the user interface of the Application.",
                "onlyInApp": "By concluding the Contract for Provision of Services, the User implicitly confirms that the supplementation and/or correction of errors/deficiencies/incorrectness of the data provided by the User can only be done in the user interface of the Application before completing the order.",
                "editDocument": "By concluding the Contract for Provision of Services, the User implicitly confirms that the Generated Documents cannot be edited [i.e., changed, supplemented, deleted, etc.] for technical reasons.",
                "incidentsFromContract": "The obligation of the Operator to deliver the Generated Documents to the User, as stipulated in the Contract for Provision of Services, has legal effect only upon payment of the Price. The User acknowledges and expressly agrees that the Operator is not obliged to deliver the Generated Documents to the User before the User pays the Price.",
                "goodPrice": "The User confirms that they consider the Price to be appropriate for the provided Application Services and does not consider the agreed Price to be contrary to good morals.",
                "afterOrderFinish": "After completing the order, the User is redirected to the secure payment gateway of the Application for the purpose of paying the Price.",
                "userAcceptPay": "The User is obliged to pay the Price to the Operator exclusively by using the secure payment gateway of the Application; the use of other payment methods does not fulfill the User's obligation to pay the Price to the Operator.",
                "threeTimes": "The User has three [3] attempts to pay the Price using the secure payment gateway of the Application.",
                "afterPay": "No claim of the User against the Operator or any claim of a third party against the Operator can be offset against the Operator's claim for payment of the Price.",
                "paymentDocument": "The Operator issues a proper invoice to the User based on the scope of the provided Application Services. The invoice includes a specification of the provided Application Services.",
                "serviceTax": "The User hereby expresses consent, in accordance with § 71(1)(b) of Act No. 222/2004 Coll. on Value Added Tax, to issue an electronic invoice. The invoice will be delivered exclusively electronically to the email address provided by the User in the order form of the Application upon order completion. The Operator will promptly send the invoice to the User upon payment of the Price. The invoice is considered delivered to the User at the moment it is sent to the email address provided by the User in the order form of the Application upon order completion. Valid delivery of the invoice to the User also occurs if the User provides a non-existent/non-functioning/incorrect/invalid email address in the order form of the Application.",
                "noInterest": "The Operator and the User agreed that the Operator is not obligated to deliver to the User any protocol, personally or otherwise, or any records after the provision of the Application Services, as the User is only interested in receiving the Generated Documents and has no interest in the record keeping.",
                "operatorAcceptLaw": "The Operator complies with the legally binding regulations in the Slovak Republic and the binding regulations and guidelines of the Slovak Bar Association when providing the Application Services.",
                "contractCancel": "The Service Agreement is automatically canceled by the futile expiration of the User's third attempt to pay the Price using the secure payment gateway of the Application; such cancellation of the Service Agreement results in",
                "contractCancelOne": "the loss of all data entered by the User in the Application and ",
                "contractCancelTwo": "redirecting the User to the home page of the Application.",
                "operatorAfterContract": "The Operator's claims arising from the Service Agreement do not cease even after the termination of the Service Agreement.",
                "articleNumberFour": "Article IV.",
                "responsibility": "Responsibility for the content of the Generated Documents",
                "makeLawPart": "The Operator is obliged to create the Legal Section of the Document in such a way that, within the scope of the User's chosen order of the Application Services, the Generated Documents contain all essential legal requirements relevant to proceedings in matters of the commercial register according to the Civil Non-Contentious Rules.",
                "deleteOne": "The Operator reserves the right to delete the content of the Data entered by the User at any time if it violates the provisions of Article II, point 30 of these Terms and Conditions or",
                "deleteTwo": "if there is suspicion that it could potentially violate these Terms and Conditions.",
                "deleteThree": "The Operator reserves the right to:",
                "operatorTakes": "temporarily or permanently, entirely or partially interrupt the possibility of entering Data by the User;",
                "partTime": "perform technical downtime of the Application at any time, even without any prior notice,",
                "anyTime": "without limitations, exercise any rights arising from these Terms and Conditions or legally binding regulations in the Slovak Republic.",
                "without": "The Operator is not responsible for the accuracy/truthfulness/completeness of the Data entered by the User.",
                "userAcceptResponsibility": "The User fully accepts exclusive responsibility for actions performed when using the Application, especially in relation to the selection, use, settings, and entry of Data by the User.",
                "content": "Entering the content of the Data by the User does not imply that the Operator identifies with their content, accuracy, truthfulness, and/or completeness.",
                "artivleNumberFive": "Article V.",
                "lawOfAuthor": "Intellectual Property Law",
                "author": "The Application is a copyrighted work, and its proprietary rights are exercised by the Operator and protected primarily by the Copyright Act and other relevant legal regulations legally binding in the Slovak Republic.",
                "operatorProperty": "The Operator has all the proprietary rights to the Application, and exclusively the Operator is authorized to grant consent/license for the use of the Application. The terms of use of the Application are determined, issued, and modified solely by the Operator.",
                "operatorCanUse": "The Operator allows the User to use the Application exclusively for personal and non-commercial purposes. By accepting these Terms of Use, the User agrees not to use any Application Services for purposes other than those stated in the previous sentence. By delivering the Generated Documents, the User's authorization to use the Application ends.",
                "cantAnalyse": "The User is not authorized to analyze, modify, edit, supplement, reproduce, process, distribute, translate the Application from machine code to source language, freely modify, or adapt the Application according to their needs, either directly or through third parties.",
                "noCopy": "The User is not authorized to make backup copies of the Application, either directly or through third parties, as such reproduction of the Application is not necessary for the functioning or use of the Application.",
                "cantTest": "The User is not authorized to examine or test the functionality of the Application for the purpose of identifying the principles on which the Application was based and created, or for the purpose of identifying the principles on which any element of the Application was based and created. Violation of the Terms of Use according to this point by the User is grounds for immediate blocking of the User in the Application, with which the User expressly and unconditionally agrees. The Operator's right to compensation for damages against the User is not affected by this.",
                "cantOwn": "By using the Application, the User does not acquire ownership or any property or personal rights to the Application, software, or any of their components.",
                "userAndOperator": "The User and the Operator hereby agree that",
                "operatorOwn": "any data entered by the User into the database contained in the Application are part of the database collected by the Operator, and",
                "databaseOwner": "the Operator is the exclusive founder of the database. The User does not acquire any rights to the database contained in the Application.",
                "articleNumber": "Article VI",
                "finalDecision": "Final Provisions",
                "userAgree": "The User agrees",
                "userAgreeOne": "to the processing of personal data to the extent specified in the Personal Data Processing Consent and",
                "userAgreeTwo": "to the processing of cookie files to the extent specified in the Cookie Processing Consent.",
                "lawOfState": "These Terms of Use are governed by the legal order of the Slovak Republic. The legal relationship between the Operator and the User is governed by the law of the Slovak Republic, in particular the Commercial Code. Any disputes between the Operator and the User will be resolved materially and locally by the competent court according to the Operator's registered office.",
                "changeVOP": "The Operator reserves the right to change these Terms of Use. The change to the Terms of Use is valid and effective on the date specified in the Terms of Use. The Operator will publish the new Terms of Use by placing them on the website.",
                "userAndOperatorAccept": "The Operator and the User have agreed to fully acknowledge electronic communication via email and the internet as valid and binding for both contracting parties."
            },
            "VotingImputBox": {
                "voteYes": "For",
                "votingMaybe": "Abstain",
                "voteNo": "Against",
                "numberOfVotes": "Number of votes:",
                "forChange": "If this partner did not participate in the vote on this agenda item, first disable the option 'All partners were present at the general meeting' that you checked in the initial point 2 titled 'Which partners participated in the general meeting?'",
                "forChangeTwo": "If this partner did not vote to adopt the decision on this agenda item, first disable the option 'All partners voted to approve all agenda items' in the initial point 2 titled 'Which partners participated in the general meeting?'",
                "here": "Participated",
                "notImportant": "His votes are not taken into account",
                "voteCanOnly": "Only the partner who participated in the vote can vote on this agenda item",
                "forVote": "To allow the partner to vote, you must specify the percentage of votes belonging to this partner in the initial point 2 titled 'Which partners participated in the general meeting?'",
                "forVoteInput": "To allow the partner to vote, you must specify the percentage of votes belonging to this partner in the initial point 2 titled 'Which partners participated in the general meeting?'",
                "voting": "Voting",
                "votingCount": "% of votes.",
                "accepted": "The resolution has been adopted",
                "border": "To hold a general meeting, you need:",
                "percents": "To approve, you need:",
                "herePeople": "% of votes from present partners.",
                "allPeople": "% of votes from all partners.",
                "noPeople": "No partners",
                "notRecognizable": "The general meeting is not capable of making resolutions"
            },
            "ZivnostNewBox": {
                "remove": "Remove",
                "enterRange": "Specify this trade as it is written in the professional qualification document",
                "range": "Rewrite the scope of this trade from the professional qualification document",
                "activity": "The added business subject is",
                "activityPlaceholder": "Enter the exact name",
                "choose": "I want to add a trade",
                "chooseButton": "Choose from the list",
                "orEnter": "I want to add a non-trade",
                "add": "Enter the business subject",
                "chooseAcitivity": "Choose from the list of trade authorizations registered by the trade office"
            },
            "CheckouFormBox": {
                "invoiceDocs": "Invoicing details",
                "makeInvoice": "I want to invoice to another company",
                "company": "Company name",
                "companyAdress": "Registered address",
                "dic": "VAT ID",
                "icdph": "VAT number",
                "contactData": "Contact details",
                "nameSurname": "First and Last Name",
                "enterValidMail": "Please enter a valid email.",
                "phone": "Phone number",
                "enterValidPhone": "Please enter a valid phone number.",
                "docs": "Documentation:",
                "moenyFor": "Fee for document preparation",
                "representing": "Representation:",
                "moneyForRepresenting": "Fee for representation",
                "withoutWat": "Total without VAT",
                "with20Wat": "VAT 20%",
                "fees": "Court and administrative fees:",
                "courtFee": "Court fee",
                "sendingFee": "Credited amount",
                "finalAmount": "Final amount",
                "acceptTips": "I accept lawyer's advice and recommendations",
                "iaccept": "I agree to the",
                "universalRules": "General Terms and Conditions",
                "aboutContract": "Service Agreement",
                "finishOrder": "Complete the order with an obligation to pay"
            },
            "LoadOrderModalBox": {
                "password": "Password for the form",
                "loadContent": "Load the form"
            },
            "LoginModalBox": {
                "loading": "Loading...",
                "loginRegister": "Login / Register",
                "login": "Login",
                "register": "Register",
                "forgot": "Forgot password",
                "operator": "The portal is operated by",
                "youCanPayWith": "You can securely pay on this page via:",
                "rules": "General Terms and Conditions",
                "gdpr": "Personal Data Protection",
                "emailControll": "Your email has not been verified. To verify, enter the code you received by email after registration.",
                "controlCode": "Verification code",
                "controll": "Verify",
                "resendEmail": "To resend the verification email, click here.",
                "resend": "Resend",
                "forNewPass": "To reset your password, enter the email you used during registration.",
                "youUsed": " you used during registration",
                "yourMail": "Your email",
                "userName": "Username",
                "sendCode": "Send verification code",
                "codeSms": "To verify, enter the code you received via SMS.",
                "resendSms": "To resend the verification SMS, click here.",
                "reControl": "Resend",
                "logOut": "Log out",
                "myOrders": "My orders",
                "password": "Password"
            },
            "OrderStatusFormBox": {
                "orderStatus": "Order status",
                "dateOfOrder": "Delivery date",
                "smallCompany": "Sole proprietorship",
                "numberOf": "Submission number",
                "recieveDate": "Submission date",
                "lawBuilding": "Office",
                "chooseOffice": "Choose the trade office",
                "court": "Court",
                "chooseCourt": "Choose the court",
                "dateOfUrgent": "Date of urgency",
                "dateOfWrite": "Date of recording",
                "saveOrder": "Save order",
                "addFiles": "Add files",
                "addDateOfWrite": "Recording date"
            },
            "PasswordResetFormBox": {
                "resetPassword": "Password reset",
                "authCode": "Verification code",
                "password": "Password",
                "repeatPassword": "Repeat password",
                "passwordArentSame": "Passwords do not match"
            },
            "SaveOrderModalBox": {
                "saveOrder": "Save your work-in-progress document",
                "pleaseSave": "Please provide an email address where we can send a link to your work-in-progress document.",
                "youCanComeBack": "You can come back to it anytime - easily and conveniently.",
                "yourMail": "Your email",
                "yourSavedDoc": "Your work-in-progress form has been saved at",
                "updateDocs": "and will be updated every time you leave the window. To instantly update the information, click below.",
                "save": "Save"
            },
            "StepperBox": {
                "flowOfMeet": "Documents names",
                "neededToBeFill": "What needs to be filled",
                "viewOfDocs": "Preview of prepared documents",
                "firstStep": 'Fill in the data online',
                "secondStep": 'Pay for the order',
                "thirdStep": 'Email with documents',
                "fourthStep": 'Sign online with a citizen',
            },
            "UserProfileBox": {
                signatureRequests: "Žiadosti o podpis",
                "benefits": "Now you can enjoy its benefits:",
                "fastView": "You have a quick overview of your orders",
                "getAcces": "You get access to additional advantages",
                "accept": "I understand",
                "logOut": "Log out",
                "homePage": "Homepage",
                "actions": "Current actions",
                "myOrders": "My orders",
                "progress": "Track your orders",
                "actionsNow": "Current actions",
                "useActions": "Take advantage of our special actions",
                "specialPrice": "ANNUAL REPORT NOW ONLY 14.90€",
                "weCanHelp": "We can help you make the approval of the annual report as easy as possible and be at ease without fines",
                "OrderDocs": "Just order the documents needed to approve the annual report from us and you will have everything you need in your email within 5 minutes.",
                "offerEnds": "Offer valid until June 30, 2023.",
                "iWantDocs": "I want the annual report",
                "videoBlog": "Video Tutorials",
                "preparing": "Preparing..."
            },
            "UserRegistrationBox": {
                "surname": "Last Name",
                "telephone": "Phone Number",
                "pleaseEnterFullNumber": "Please enter a valid phone number.",
                "iAgree": "I agree to receive marketing campaigns"
            },
            "UserOrderBox": {
                "close": "Close",
                "open": "Open",
                "download": "Download",
                "created": "Created",
                "state": "State",
                "numberInOffice": "Office submission number",
                "dateInOffice": "Office submission date",
                "office": "Office",
                "addedToOffice": "Office registry",
                "dateOnCourt": "Court submission date",
                "court": "Court",
                "addedToCourt": "Court registry",
                "urgentToOffice": "Urgent to office",
                "urgentToCourt": "Urgent to court",
                "writtenToOffice": "Written to office",
                "writtenToCourt": "Written to court"
            },
            "OrderListBox": {
                requester: "Žiadateľ",
                "nameOfSro": "Company Name",
                "ico": "Company ID",
                "stateOfOrder": "Order status",
                "stateOfPay": "Payment status",
                "priceOfOrder": "Total order amount",
                "dateOfCreate": "Creation date"
            },
            "UserListBox": {
                // "username": "Cognito meno",
                // "userstatus": "Stav užívateľa",
                "given_name": "Krstné meno",
                "family_name": "Priezvisko",
                "email": "Email",
                // "email_verified": "Email overený",
                // "phone_number": "Telefónne číslo",
                // "phone_number_verified": "Telefónne číslo overené",
                // "custom_marketing_suhlas": "Marketingový súhlas",
                "actions": "Operácie"
            },
            "ErrorPageBox": {
                "cantDo": "We're sorry, the selected action cannot be performed.",
                "chooseAnotherCompany": "Choose another company"
            },
            "FrontOfficeBox": {
                "cleanigDay": "Planned maintenance of the portal will take place. Thank you for your understanding | MOJEZMLUVY.SK Team",
                "day": "Day"
            },
            "BaseInvestmentRaiseBox": {
                "newInput": "Liabilities for new deposits will be assumed by:",
                "add": "Add",
                "ico": "Company ID",
                "birthID": "Birth ID",
                "idData": "Identification data",
                "enter": "Enter",
                "owner": "owner",
                "birthIdOrId": "Birth ID or identification data",
                "icoOrId": "Company ID or identification data",
                "chooseOwnerOne": "Choose a partner",
                "coOwner": "Co-owner",
                "chooseBirthDate": "Choose date of birth",
                "chooseOwner": "Does the partner have",
                "orData": "or other identification data?",
                "localCourt": "Local court",
                "birthDate": "Date of birth",
                "enterLocalCourt": "Enter local court",
                "part": "Part",
                "insert": "Insert",
                "enterPart": "Enter part",
                "enterInsert": "Enter insert",
                "remove": "Remove",
                "enterRepresentMan": "Add a representative person",
                "enterAmount": "The commitment to a new deposit in the BIR is in the amount of",
                "enterAmountEUR": "After the increase, the partner's deposit in the BIR will be €",
                "represent": "Authorized representative",
                "enterFunc": "Enter their function",
                "func": "Function",
                "enterName": "Enter a name",
                "nameTitleSurname": "Title, name, surname"
            },
            "BaseInvestmentRaiseFromProfitComponentBox": {
                "add": "Add",
                "partsOfOwners": "Owners' shares in the base investment will change as follows:",
                "chooseOwner": "Choose a partner",
                "owner": "Owner",
                "ofOwner": "of the owner",
                "ico": "Company ID",
                "birthIdOrId": "Birth ID or identification data",
                "icoOrId": "Company ID or identification data",
                "newAmount": "Enter the new amount of the share in EUR",
                "idData": "Identification data",
                "birthId": "Birth ID",
                "enter": "Enter",
                "chooseIfOwner": "Does the partner have",
                "addRepresentMan": "Add a representative person",
                "orData": "or other identification data?",
                "dateOfBirth": "Date of birth",
                "enterLocalCourt": "Enter local court",
                "localCourt": "Local court",
                "enterPart": "Enter part",
                "part": "Part",
                "enterInsert": "Enter insert",
                "insert": "Insert",
                "remove": "Remove",
                "representMan": "Authorized representative",
                "enterFunc": "Enter their function",
                "func": "Function",
                "enterName": "Enter a name",
                "nameTitle": "Title, name, surname"
            },
            "DepositAdministratorBox": {
                "chooseAdmin": "Who is the deposit administrator?",
                "chooseAdminTooltip": "Select a partner who manages the deposits of partners into the company's basic capital for the registration of the company in the commercial register.",
                "chooseOwner": "choose a partner",
                "enteBusinessName": "Enter the Business Name",
                "businessName": "Business Name",
                "businessAdress": "Enter the address",
                "streetPSC": "street, number, postal code, city",
                "chooseCountry": "Choose a country",
                "country": "Country",
                "ico": "Company ID",
                "representMan": "Authorized representative",
                "enterFunc": "Enter their function",
                "func": "Function",
                "enterName": "Enter a name",
                "nameTitle": "Title, name, surname",
                "enterRepresent": "Add an authorized representative"
            },
            "DozornaRadaComponentBox": {
                "titlesBefore": "Titles before the name of the supervisory board member are",
                "titlesAfter": "Titles after the name of the supervisory board member are",
                "firstName": "The first name of the supervisory board member is",
                "lastName": "The last name of the supervisory board member is",
                "birthId": "Does the supervisory board member have a birth ID?",
                "birthIdPlaceholder": "select a birth ID or another identification data",
                "birthIdTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It is necessary to select one of the options.",
                "enterBirthId": "The birth ID / identifier of the supervisory board member is",
                "enterBirthIdPlaceholder": "enter the birth ID or another identification data",
                "enterBirthIdTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It needs to be filled in here.",
                "member": "The supervisory board member is",
                "memberTooltip": "The full name and surname of the supervisory board member, along with any titles, must be correctly entered.",
                "address": "The address of the supervisory board member is",
                "addressTooltip": "The address of the supervisory board member's residence must be specified correctly and with sufficient precision.",
                "sepervisoryMember": "Does the supervisory board member have",
                "orIdentity": "or another identification data?",
                "enterIdentity": "Enter an identification data",
                "enterBirth": "Select a date of birth",
                "birth": "Date of birth",
                "enterFunc": "Enter their function",
                "func": "Function",
                "addMember": "Add a supervisory board member",
                "sepervisoryExists": "Selection of optional company bodies",
                "sepervisoryExistsTooltip": "The supervisory board is usually not established in limited liability companies. If it is established, it serves to control the executives and accounting."
            },
            "KonateliaEstablishmentBox": {
                "titlesBefore": "Titles before the name of the executive are",
                "titlesAfter": "Titles after the name of the executive are",
                "firstName": "The first name of the executive is",
                "lastName": "The last name of the executive is",
                "konatel": "The executive is",
                "konatelTooltip": "The full name and surname of the executive, along with any titles, must be correctly entered.",
                "enterAdress": "The address of the executive is",
                "enterAdressTooltip": "The address of the executive's residence must be specified correctly and with sufficient precision.",
                "chooseIf": "Does the executive have a birth ID?",
                "chooseIfPlaceholder": "select a birth ID or another identification data",
                "chooseIfTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It is necessary to select one of the options.",
                "enterBirthID": "The birth ID / identifier of the executive is",
                "enterBirthIDTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It needs to be filled in here.",
                "enterData": "Enter an identification data",
                "enterICO": "Enter a Company ID",
                "ICO": "Company ID",
                "birthID": "Birth ID",
                "identication": "enter the executive's business name",
                "chooseBirthDate": "Select a date of birth",
                "birthDate": "Date of birth",
                "addOwner": "Add an executive",
                "removeOwner": "Remove an executive"
            },
            "OwnersComponentBox": {
                "allPeopleMeet": "All partners attended the general meeting",
                "allPeopleVotedForOne": "All partners voted to approve all agenda items",
                "partOwner": "Partner",
                "present": "Attended",
                "choosePersonType": "Is it a person?",
                "personType": "Person Type",
                "individual": "Individual",
                "legalPerson": "Legal Person",
                "enterVotes": "Voting share in %",
                "enterCompanyName": "Enter the partner's business name",
                "enterName": "Enter the partner's name and surname",
                "name": "Enter a name",
                "enterAdress": "Enter the partner's address",
                "enterCompanyAdress": "Enter the partner's residence",
                "savedPersonsButton": "Select from saved persons",
                "savePerson": "Save person",
                "personInformation": "Person's Identification Information",
                "searchPerson": "Search for a person",
                "enterNameAndSurname": "Enter a name or identification data",
                "personName": "First Name",
                "personSurname": "Last Name",
                "id": "Identification Data",
                "searchOrsr": "Search in ORSR"
            },
            "OwnersEstablishmentBox": {
                "titlesBefore": "Titles before the name of the partner are",
                "titlesAfter": "Titles after the name of the partner are",
                "firstName": "The first name of the partner is",
                "lastName": "The last name of the partner is",
                "shareCapital": "What will be the value of the share capital in €",
                "choosePersonType": "Is it a person?",
                "owner": "The partner is",
                "personType": "Person Type",
                "individual": "Individual",
                "legalPerson": "Legal Person",
                "depositeEuro": "Enter the deposit in €",
                "paidDepositeEuro": "Enter the paid deposit in €",
                "shareCompanyPart": "Enter the share in the company in %",
                "shareProfit": "Enter the share in profit in %",
                "enterBusinessName": "The partner's current business name must be entered correctly",
                "enterTitleNameTooltip": "The partner's full name and surname, along with any titles, must be entered correctly",
                "enterTitleName": "Enter their title, first name, and last name",
                "businessName": "Business Name",
                "titleName": "Title, First Name, and Last Name",
                "partnerForeginer": "Is the partner a foreign person?",
                "depositManager": "Is this partner a deposit manager?",
                "partnerExecutive": "Is this partner also an executive?",
                "enterHomeLocation": "The partner's registered office is",
                "enterHomeLocationTooltip": "The current address of the partner's registered office must be entered correctly and with sufficient precision",
                "enterCompanyAdress": "The partner's residence is",
                "enterCompanyAdressTooltip": "The partner's residence address must be entered correctly and with sufficient precision",
                "ownerHaveBirthId": "Does the partner have a birth ID?",
                "ownerHaveOtherId": "Does the partner have a Company ID?",
                "ICO": "select a Company ID",
                "ICOTooltip": "In some countries, legal entities are not assigned a Company ID, but they receive other identification data. It is necessary to select one of the options.",
                "birthID": "select a birth ID",
                "birthIDTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It is necessary to select one of the options.",
                "orID": "or other identification data?",
                "dataID": "Identification Data",
                "enterICO": "The Company ID / identifier of the partner is",
                "enterICOTooltip": "In some countries, legal entities are not assigned a Company ID, but they receive other identification data. It needs to be filled in here.",
                "enterICOPlaceholder": "enter a Company ID or another identification data",
                "enterBirthID": "The birth ID / identifier of the partner is",
                "enterBirthIDTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It needs to be filled in here.",
                "enterBirthIDPlaceholder": "enter a birth ID or another identification data",
                "enterID": "Enter an identification data",
                "chooseBirthDate": "Select a date of birth",
                "birthDate": "Date of birth",
                "representMan": "The following person will sign on behalf of the partner:",
                "enterFunc": "From what position?",
                "func": "e.g. executive"
            },
            "EstablishmentSinglePerson": {
                "titlesBefore": "Titles before the name of the partner are",
                "titlesAfter": "Titles after the name of the partner are",
                "firstName": "The first name of the partner is",
                "lastName": "The last name of the partner is",
                "shareCapital": "What will be the value of the share capital in €",
                "choosePersonType": "Is it a person?",
                "personType": "Person Type",
                "individual": "Individual",
                "legalPerson": "Legal Person",
                "enterBusinessName": "The partner is",
                "enterBusinessNameTooltip": "The current business name of the partner must be entered correctly",
                "enterTitleName": "Enter their title, first name, and last name",
                "businessName": "Business Name",
                "titleName": "Title, First Name, and Last Name",
                "partnerForeginer": "Is the partner a foreign person?",
                "depositManager": "Is this partner also a deposit manager?",
                "partnerExecutive": "Is this partner also an executive?",
                "enterHomeLocation": "The partner's residence is",
                "enterCompanyAdress": "The partner's registered office is",
                "enterCompanyAdressTooltip": "The current address of the partner's registered office must be entered correctly and with sufficient precision",
                "enterHomeLocationTooltip": "The address of the partner's residence must be entered correctly and with sufficient precision",
                "ownerHaveBirthId": "Does the partner have a birth ID?",
                "ownerHaveOtherId": "Does the partner have a Company ID?",
                "ICO": "select a Company ID",
                "ICOTooltip": "In some countries, legal entities are not assigned a Company ID, but they receive other identification data. It is necessary to select one of the options.",
                "birthID": "select a birth ID",
                "birthIDTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It is necessary to select one of the options.",
                "orID": "or other identification data?",
                "dataID": "Identification Data",
                "enterICO": "The Company ID / identifier of the partner is",
                "enterICOPlaceholder": "enter a Company ID or another identification data",
                "enterICOTooltip": "In some countries, legal entities are not assigned a Company ID, but they receive other identification data. It needs to be filled in here.",
                "enterBirthID": "The birth ID / identifier of the partner is",
                "enterBirthIDPlaceholder": "enter a birth ID or another identification data",
                "enterBirthIDTooltip": "In some countries, individuals are not assigned a birth ID, but they receive other identification data. It needs to be filled in here.",
                "enterID": "Enter an identification data",
                "chooseBirthDate": "Select a date of birth",
                "birthDate": "Date of birth",
                "representMan": "The following person will sign on behalf of the partner:",
                "enterFunc": "From what position?",
                "func": "e.g. executive",
                "addRepresent": "Add a representative person",
                "owner": "The partner is",
                "enterTitleNameTooltip": "The partner's full name and surname, along with any titles, must be entered correctly"
            },
            "SingleOwnerBox": {
                "chooseOneType": "Is the sole partner an individual?",
                "personType": "Person Type",
                "individual": "Individual",
                "legalPerson": "Legal Person",
                "enterOneOwnerCompanyName": "Enter the business name of the sole partner",
                "enterOwnerName": "Enter the name of the sole partner",
                "name": "Name",
                "enterOwnerLocation": "Enter the registered office address of the sole partner",
                "enterOwnerAdress": "Enter the residential address of the sole partner",
                "ifOwnerHave": "Does the partner have",
                "ICO": "Company ID",
                "birthID": "birth ID",
                "orID": "or other identification data?",
                "dataID": "Identification Data",
                "enterICO": "Enter the Company ID",
                "enterBirthID": "Enter the birth ID",
                "enterID": "Enter an identification data",
                "chooseBirthDate": "Choose a date of birth",
                "birthDate": "Date of birth",
                "representMan": "Authorized representative",
                "enterFunc": "Enter their position",
                "func": "Position",
                "addRepresent": "Add an authorized representative",
                "enter": "Enter",
                "partner": "partner",
                "enterPartnerBirthDate": "Enter the partner's date of birth",
                "enterTitleName": "Enter their title, first name, and last name",
                "titleName": "Title, First Name, and Last Name"
            },
            "RetributionBox": {
                "withPayback": "For the purchase price",
                "withoutPayback": "Without consideration",
                "enterPaybackValue": "The amount of the purchase price is",
                "paybackValue": "Amount of the purchase price",
                "chooseExp": "The maturity of the purchase price is",
                "exp": "Maturity",
                "untilDate": "Until the date",
                "withSign": "Upon signing this agreement",
                "chooseExpDate": "Choose the maturity date",
                "expDate": "Maturity Date",
                "choosePayment": "Choose the method of payment",
                "cash": "In cash",
                "transfer": "By bank transfer",
                "didAccept": "Did the transferee accept the agreed consideration?",
                "iban": "IBAN"
            },
            "PlnomocenstvoHeader": {
                "enterFullOwner": "Enter the authorizing executive or procurator"
            },
            "PresenceComponent": {
                "personsHere": "Persons present",
                "personType": "Person Type"
            },
            "PresenceKonatel": {
                "chooseOwner": "Choose the executive",
                "enterFunc": "Enter their position",
                "func": "Position",
                "enterName": "Enter the name",
                "titleName": "Title, First Name, and Last Name",
                "enterAdress": "Enter the address",
                "streetCity": "Street No., ZIP Code, City",
                "representMan": "Representative "
            },
            "PresenceOtherPerson": {
                "enterFunc": "Enter their position",
                "func": "Position",
                "enterName": "Enter the name",
                "titleName": "Title, First Name, and Last Name",
                "enterAdress": "Enter the address",
                "streetCity": "Street No., ZIP Code, City",
                "representMan": "Representative "
            },
            "PresenceProkurista": {
                "chooseProxy": "Choose the procurator",
                "proxy": "Procurator",
                "enterFunc": "Enter their position",
                "func": "Position",
                "enterName": "Enter the name",
                "titleName": "Title, First Name, and Last Name",
                "enterAdress": "Enter the address",
                "streetCity": "Street No., ZIP Code, City",
                "isHeRpresent": "Is someone representing them?",
                "enterRepresent": "Add an authorized representative",
                "representMan": "Authorized Representative",
                "enterCountry": "Select a country",
                "country": "Country"
            },
            "PresentOwnerPerson": {
                "coOwner": "Partner",
                "enterFunc": "Enter their position",
                "func": "Position",
                "enterName": "Enter the name",
                "titleName": "Title, First Name, and Last Name",
                "enterAdress": "Enter the address",
                "streetCity": "Street No., ZIP Code, City",
                "isHeRpresent": "Is someone else representing them?",
                "enterRepresent": "Add a representative",
                "representMan": "Representative "
            },
            "LossComponent": {
                "enterLoss": "Enter the loss",
                "useToPay": "Use profits from previous years to cover the loss?",
                "feeToPay": "Use partner contributions to cover the loss?",
                "year": "Year",
                "enterValue": "Enter the value",
                "value": "Value",
                "coOwnerPay": "Partner contribution"
            },
            "ProfitComponent": {
                "enterProfit": "Enter the profit",
                "profit": "Profit",
                "enterReserve": "Enter the contribution to the reserve fund",
                "resrveFoundation": "Contribution to the reserve fund",
                "enterSocialReserve": "Enter the contribution to the social fund",
                "socialFoundation": "Contribution to the social fund",
                "enterBaseReserve": "Enter the profit allocated to increase the share capital",
                "baseFoundation": "Profit allocated to increase the share capital",
                "enterProfitToSplit": "Enter the profit allocated for distribution among partners",
                "profitToSplit": "Distribution of profit among partners",
                "enterName": "Enter the name",
                "name": "Name",
                "enterValue": "Enter the value",
                "value": "Value"
            },
            "PropertyOwner": {
                "titlesBefore": "Titles before the owner's name are",
                "titlesAfter": "Titles after the owner's name are",
                "firstName": "The owner's first name is",
                "lastName": "The owner's last name is",
                "enterTypeOfOwner": "Is the owner an individual?",
                "enterICO": "The owner's ID number is",
                "enterICOPlaceholder": "enter the ID number or other identification information",
                "enterBirthID": "The owner's birth ID number is",
                "enterBirthIDPlaceholder": "enter the birth ID number or other identification information",
                "typeOfOwner": "Type of person",
                "individual": "Individual",
                "legalPerson": "Legal entity",
                "enterOwner": "The owner is",
                "enterOwnerTooltip": "The owner's full name, including all titles, must be entered correctly",
                "enterOwnerName": "The owner is",
                "enterOwnerNameTooltip": "The owner's current business name must be entered correctly",
                "titleName": "Title, First Name, and Last Name",
                "businessName": "Business Name",
                "streetCity": "Street No., ZIP Code, City",
                "enterOwnerLocation": "The owner's place of residence is",
                "enterAdress": "The owner's registered office is",
                "enterOwnerBirth": "The owner's date of birth",
                "dateOfBirth": "Date of Birth",
                "chooseIfOwner": "Does the owner have",
                "ico": "ID number",
                "hasIco": "Does the owner have an ID number?",
                "hasIcoTooltip": "In some countries, legal entities do not have ID numbers but receive other identification information. One of the options must be selected.",
                "IcoTooltip": "In some countries, legal entities do not have ID numbers but receive other identification information. Enter the identification information here.",
                "BirthIDTooltip": "In some countries, individuals do not have birth ID numbers but receive other identification information. Enter the identification information here.",
                "birthID": "Birth ID number?",
                "hasBirthID": "Does the owner have a birth ID number?",
                "hasBirthIDTooltip": "In some countries, individuals do not have birth ID numbers but receive other identification information. One of the options must be selected.",
                "orID": "or identification information",
                "id": "Identification Information",
                "enter": "Enter",
                "owner": "owner",
                "birtIdOrId": "Birth ID number or identification information",
                "icoOrId": "ID number or identification information",
                "enterRegistrationDisctrict": "Enter the registration district court",
                "registrationDistrict": "Registration District Court",
                "enterPart": "Enter the part",
                "part": "Part",
                "enterInsert": "Enter the insert",
                "insert": "Insert",
                "addRepresentMan": "Add a representative person",
                "representMan": "The following person will sign on behalf of the owner:",
                "enterFunc": "What is their position?",
                "func": "e.g. executive",
                "enterRepresentMan": "Enter their title, first name, and last name",
                "tooltipPerson": "The owner's residential address must be specified correctly and precisely",
                "tooltipCompany": "The owner's current registered office address must be specified correctly and precisely"
            },
            "PropertyType": {
                "enterTypeOfProperty": "The property in which the registered office will be located is",
                "enterTypeOfPropertyPlaceholder": "select the type of property",
                "enterTypeOfPropertyTooltip": "If it is not a flat or non-residential space, it is a building with an inventory number.",
                "typeOfProperty": "Type of Property",
                "building": "Building",
                "flat": "Flat",
                "noResidentPlace": "Non-Residential Space",
                "flatNumber": "Enter the flat number",
                "noResidentNumber": "Enter the non-residential space number",
                "enterEntrance": "Enter the entrance",
                "entrance": "Entrance",
                "enterFloor": "Enter the floor",
                "floor": "Floor",
                "enterInventoryNumber": "Enter the inventory number",
                "inventoryNumber": "Inventory Number",
                "enterDeedNumber": "Enter the deed number",
                "deedNumber": "Deed Number",
                "enterSizeOfShare": "Enter the size of the share in common areas",
                "sizeOfShare": "Size of Share in Common Areas",
                "enterDistrictOffice": "Enter the district office",
                "districtOffice": "District Office",
                "enterCadastralTerritory": "Enter the cadastral territory",
                "cadastralTerritory": "Cadastral Territory",
                "enterMunicipality": "Enter the municipality",
                "municipality": "Municipality",
                "enterDistrict": "Enter the district",
                "district": "District",
                "chooseParcelType": "Choose the type of parcel register",
                "parcelRegister": "Parcel Register",
                "enterParcelNumber": "Enter the parcel number",
                "parcelNumber": "Parcel Number",
                "enterTypeOfLand": "Enter the type of land",
                "enterTypeOfBuilding": "Enter the type of building",
                "typeOfLand": "Type of Land",
                "typeOfBuilding": "Type of Building",
                "addParcel": "Add Parcel"
            },
            "NewOwnerComponent": {
                "willOwnerHaveThisPart": "Will the partner keep this part?",
                "part": "Part",
                "enterShareEur": "Enter the share in €",
                "shareInEur": "at least €750",
                "enterSharePercents": "Enter the share in %",
                "shareInPercents": "Share in %",
                "chooseTypeOfPerson": "Is the buyer an individual?",
                "typeOfPerson": "Type of Person",
                "searchORSR": "Shall we search for them in the Commercial Register of the Slovak Republic database?",
                "searchWithNameOrICO": "enter the ID number or business name",
                "enterName": "Enter the title, first name, and last name of the buyer",
                "enterBusinessName": "Enter the business name of the buyer",
                "titleName": "enter the full name",
                "enterHomeLocation": "Enter the residence of the buyer",
                "enterAdress": "Enter the address of the buyer",
                "chooseDateOfBirth": "Date of birth of the buyer",
                "dateOfBirth": "enter the date of birth",
                "chooseIfNewOwner": "Does the buyer have",
                "ico": "ID number",
                "birthID": "birth ID number",
                "orID": "or do they have another identification information?",
                "dataID": "Identification Information",
                "enter": "Enter",
                "newOwner": "the buyer",
                "orDataId": "or identification information"
            },
            "OwnerComponent": {
                "guideOp": "Who is selling the business share?",
                "chooseDateOfBirth": "Date of birth of the seller",
                "dateOfBirth": "enter the date of birth",
                "chooseConverterHave": "Does the seller have",
                "ico": "ID number",
                "birthID": "birth ID number",
                "orID": "or do they have another identification information?",
                "dataID": "Identification Information",
                "enter": "Birth ID number / ",
                "converter": "the seller is",
                "enterPart": "The amount of the seller's contribution in € is",
                "part": "enter the amount",
                "enterSharePercents": "The seller's business share is in %",
                "shareInPercents": "Share in %",
                "enterPartsToCut": "How many parts do you want to divide the share into?",
                "partsToCut": "Enter a number"
            },
            "ShareDivision": {
                "capital": "Share capital in €",
                "addRepresent": "Add another signatory?",
                "representMan": "The buyer will sign on behalf of:",
                "enterFunc": "From what position?",
                "func": "e.g., executive",
                "enterName": "Enter their title, first name, and last name",
                "titleName": "title, first name, last name",
                "representManSeller": "The seller will sign on behalf of:"
            },
            "ShareDivisionSinglePerson": {
                "capital": "Share capital in €",
                "addRepresent": "Add another signatory?",
                "representMan": "The buyer will sign on behalf of:",
                "enterFunc": "From what position?",
                "func": "e.g., executive",
                "enterName": "Enter their title, first name, and last name",
                "titleName": "title, first name, last name",
                "representManSeller": "The seller will sign on behalf of:"
            },
            "SecondNewOwnerComponent": {
                "enterNewOwner": "Who is buying the business share?",
                "chooseTypeOfPerson": "Is it an individual?",
                "typeOfPerson": "Type of Person",
                "individual": "Individual",
                "legalPerson": "Legal Person",
                "searchORSR": "Shall we search for them in the Commercial Register of the Slovak Republic database?",
                "searchWithNameOrICO": "enter the ID number or business name",
                "enterName": "Enter the title, first name, and last name of the buyer",
                "enterBusinessName": "Enter the business name of the buyer",
                "titleName": "enter the full name",
                "enterHomeLocation": "Enter the residence of the buyer",
                "enterAdress": "Enter the address of the buyer",
                "name": "Name",
                "chooseIfNewOwner": "Does the buyer have",
                "enter": "Enter",
                "newOwner": "the buyer",
                "ico": "ID number",
                "birthID": "birth ID number",
                "orID": "or do they have another identification information",
                "dataID": "Identification Information"
            },
            "SecondOwnerComponent": {
                "chooseConverter": "Who is selling the business share?",
                "converter": "Enter the title, first name, and last name of the seller",
                "chooseDateOfBirth": "Date of birth of the seller",
                "dateOfBirth": "Enter the date of birth",
                "chooseConverterHave": "Does the seller have",
                "ico": "ID number",
                "birthId": "birth ID number",
                "orId": "or do they have another identification information",
                "enter": "Enter",
                "dataId": "identification information",
                "converter": "the seller",
                "enterPart": "The amount of the seller's contribution in € is",
                "part": "Enter the amount",
                "enterPartInPercent": "The seller's share is in %",
                "partInPercent": "Share in %"
            },
            "ShareTransfer": {
                "capital": "Share capital in €",
                "addRepresentMan": "Add another signatory?",
                "representMan": "The buyer will sign on behalf of:",
                "addFunc": "From what position?",
                "func": "e.g., executive",
                "addTitleName": "Enter their title, first name, and last name",
                "titleName": "Title, first name, last name",
                "representManSeller": "The seller will sign on behalf of:"
            },
            "ShareTransferSinglePerson": {
                "capital": "Share capital in €",
                "addRepresentMan": "Add another signatory?",
                "representMan": "The buyer will sign on behalf of:",
                "addFunc": "From what position?",
                "func": "e.g., executive",
                "addTitleName": "Enter their title, first name, and last name",
                "titleName": "Title, first name, last name",
                "representManSeller": "The seller will sign on behalf of:"
            },
            "TransferAquirerStatement": {
                "chooseSignatureDate": "Select the date of signing",
                "dateOfSignature": "Enter the date",
                "addPlaceOfSignature": "Where was it signed",
                "placeOfSignature": "Enter the place"
            },
            "TransferSellerStatement": {
                "chooseSignatureDate": "Select the date of signing",
                "dateOfSignature": "Enter the date",
                "addPlaceOfSignature": "Where was it signed",
                "placeOfSignature": "Enter the place"
            }
        },
        screens: {
            DitecModalBox: {
                loadingWait: "Súbory sa nahrávajú, prosím čakajte",
                didntRecognise: "Nebolo rozoznané rozšírenie D.Bridge 2, nainštalujte ho kliknutím na tlačidlo a znovu načítajte stránku.",
                didntInstalledWell: "Nebolo rozoznaná aplikácia D.Launcher 2, nainštalujte ju kliknutím na tlačidlo. Po inštalácií reštartujte počítač.",
                restartPage: "Vyskytla sa neznáma chyba, obnovte stránku a skúste to znova",
                signInProgress: "Prebieha podpisovanie",
                errorInSign: "Vyskytla sa chyba",
                continueInApp: "Pokračujte v aplikácií dSigner",

            },
            UserSignatureRequestListBox: {
                close: "Zatvoriť",
                open: "Detail žiadosti",
                didntFill: 'Nevyplnené',
                sign: "Podpísať KEP-om",
                step: "Tu niečo nesedí, preverte si to",
                signingTitle: "Podpísanie"
            },
            "ValidatorModal": {
                "title": "We found discrepancies in some fields. Do you want to continue anyway?",
                "step": "Something doesn't match here"
            }
        }
    }
})